/** Dashboard/login strings added in Phase 3 — merged into all active locales. */
import ML from './locales/ml-ui-extras.js';

const EN = {
  availableNow: 'Available Now',
  avgRating: 'Avg Rating',
  advancePaid: 'Advance Paid',
  quantityLabel: 'Quantity',
  currentlyDeployed: 'Currently Deployed',
  liveMachineLocation: 'Live Machine Location',
  quickRechargeUpi: 'Quick Recharge via UPI',
  scanToPay: 'Scan to Pay',
  quickSelect: 'Quick Select:',
  filterAll: 'All',
  filterCredit: 'Credit',
  filterDebit: 'Debit',
  txnDescription: 'Description',
  noTransactionsFilter: 'No transactions for selected filter.',
  noBookingsAccount: 'No bookings yet for this account.',
  invoiceNotAvailableCancelled: 'Invoice not available (cancelled)',
  noAlertsNow: 'No alerts right now.',
  pushNotificationsTitle: 'Push notifications',
  pushNotificationsHint: 'Browser alerts for bookings and updates. WhatsApp is separate.',
  pushStatusOn: 'Push notifications ON',
  pushStatusOff: 'Push notifications OFF',
  pushEnabledNote: 'Enabled — allow browser permission if prompted.',
  pushEnablePrompt: 'Enable push notifications for instant updates',
  downloadDisputeStatement: 'Download Dispute Statement',
  downloadInvoice: 'Download Invoice',
  bookAgain: 'Book Again',
  machineNoLongerAvailable: 'Machine no longer available',
  downloadHistoryPdf: 'Download History PDF',
  pushDisabledNote: 'Disabled — you will not receive push alerts on this device.',
  pushBrowserBlocked: 'Browser blocked notifications. Enable in site settings, then turn ON again.',
  pushPrefLoadFailed: 'Could not load notification preference.',
  pushPrefUpdateFailed: 'Could not update notification preference.',
  pushMigrationRequired: 'Database update pending — ask admin to run push_notifications migration in Supabase.',
  walletRechargeRequired: 'Your wallet needs ₹{amount}. Please recharge.',
  confirmPayBalancePrompt: 'Confirm & pay balance ₹{amount}?',
  bookingExtensionFailed: 'Extension failed',
  bookingConfirmFailed: 'Confirmation failed',
  bookingDisputeFailed: 'Dispute failed',
  sessionExpiredLogin: 'Session expired! Please login again.',
  sessionExpireWarning: 'Your session will expire in 5 minutes. Please stay active.',
  walletCreditedAlert: '₹{amount} added to your wallet!{payLine}',
  bf2AwaitingDispatch: 'Booking confirmed. Awaiting dispatch approval.',
  bf2OwnerApprovedSoon: 'Owner approved — machine will start soon.',
  bf2Active: 'ACTIVE',
  bf2MachineHoursLive: 'Machine Hours (Live)',
  bf2Booked: 'Booked',
  bf2Remaining: 'Remaining',
  bf2RunningBill: 'Running Bill',
  bf2Outstanding: 'Outstanding',
  bf2MinimumBilling: 'Minimum {hours} hrs billing applies (₹{amount})',
  bf2AdvancePaid: 'Advance Paid',
  bf2Started: 'Started',
  bf2ExtendHr: '+ Extend {hours}hr',
  bf2ExtendConfirm: '+ Extend {hours} hr — confirm?\n\nTotal: ₹{total}\nAdvance (50%): ₹{advance}\n\n₹{advance} will be deducted from your wallet.',
  bf2ExtendSuccess: '✅ {hours} hr added!\n₹{advance} debited from your wallet.',
  bf2ExtensionPending: 'Extension requested. Pay advance to continue.',
  bf2ConfirmWorkComplete: 'Confirm Work Complete',
  bf2OperatorLogged: 'Operator logged: {logged} hrs · Minimum: {min} hrs · Charged: {final} hrs',
  bf2BalanceDue: 'Balance Due: ₹{amount} (wallet)',
  bf2Deadline: 'Deadline: {time} remaining',
  bf2ConfirmPayBtn: 'Confirm & Pay ₹{amount}',
  bf2Dispute: 'Dispute',
  bf2DisputePlaceholder: 'Hours are wrong because...',
  bf2SubmitDispute: 'Submit Dispute',
  bf2DisputeRaised: 'Dispute raised. Admin is reviewing.',
  bf2CompletedSummary: 'Total: ₹{total} · Advance: ₹{advance}',
  bf2CompletedHours: ' · {hours} hrs',
  bf2ActualWorkRequired: 'Actual work time required (HH:MM:SS)',
  bf2LogWorkConfirm: 'Log {time} ({hours} hrs) for Booking #{ref}? Client will be notified.',
  bf2MarkCompleteFailed: 'Failed to mark complete',
  etaOwnerApproval: 'Awaiting owner approval',
  etaWorkInProgress: 'Estimated completion',
  etaPaymentDeadline: 'Payment confirmation deadline',
  etaWorkCompleted: 'Work completed at',
  etaDisputeReview: 'Dispute under review by DE team',
  etaMinutesRemaining: '{n} minutes remaining',
  etaHoursRemaining: '{n} hours remaining',
  bookingsCount: '{count} bookings',
  transactionsCount: '{count} transactions',
  txnDayNet: 'Day net',
  pendingCount: '{count} pending',
  directContactBlacklist: 'Direct Contact = Blacklist',
  pdfInvoiceFailed: 'Could not generate invoice PDF. Please try again.',
  pdfReportFailed: 'Could not generate report PDF. Please try again.',
  bookingFailedGeneric: 'Booking failed. Please try again.',
  siteLocationTitle: 'Site Location',
  siteLocationOptional: 'Optional — helps operator find your site faster.',
  useSavedAddress: 'Use saved address',
  useCurrentLocation: '📍 Use Current Location',
  siteAddressLabel: 'Site Address',
  sitePincodeLabel: 'Pincode',
  siteGpsLoading: 'Getting location…',
  siteGpsDenied: 'Location permission denied. Enter address manually or enable GPS.',
  siteGpsUnavailable: 'GPS unavailable. Enter address manually.',
  openInMaps: '📍 Open in Maps',
  navigateToSite: '🗺️ Navigate to Site',
  machineIdLabel: 'Machine ID',
  yearsExperience: '{n} Years',
  fuelColon: 'Fuel:',
  hrsUnit: 'hrs',
  daysUnit: 'days',
  wksUnit: 'wks',
  moUnit: 'mo',
  walletDebit: 'Wallet Debit',
  statusCancelled: 'Cancelled',
  statusCompleted: 'Completed',
  naLabel: 'N/A',
  loadedOwnerBookings: 'Loaded {count} owner bookings{suffix}',
  ownerBookingsMoreAvailable: ' (more available)',
  ownerBookingsAllLoaded: ' (all loaded)',
  machineDispatchedAt: 'Machine Dispatched — {when}',
  loginIAmQuestion: 'I am…?',
  loginPickRoleHint: 'Already registered? Pick your role and continue. New here? Use Join Us below.',
  loginRoleClientDesc: 'Book machinery for construction projects',
  loginRoleOwnerDesc: 'Manage fleet, earnings & availability',
  loginRoleOperatorDesc: 'Run assigned machines & daily logs',
  loginRoleAdminDesc: 'Platform control, approvals & operations',
  loginPortalClientTitle: 'Client Portal',
  loginPortalClientSubtitle: 'Sign in to book construction machinery',
  loginPortalOwnerTitle: 'Owner Portal',
  loginPortalOwnerSubtitle: 'Sign in to manage your fleet & registrations',
  loginPortalOperatorTitle: 'Operator Portal',
  loginPortalOperatorSubtitle: 'Sign in for assigned machines & daily logs',
  loginPortalAdminTitle: 'Admin Portal',
  loginPortalAdminSubtitle: 'Platform control & approvals',
  trustStatMachines: 'Machines',
  trustStatRating: 'Rating',
  trustStatCompliant: 'Compliant',
  signupSectionContact: 'Your details',
  signupSectionCompany: 'Company',
  signupSectionSecurity: 'Security',
  signupContactName: 'Contact Name',
  signupCompanyName: 'Company Name',
  signupCreatePassword: 'Create password',
  signupReenterPassword: 'Re-enter password',
  timeLabel: 'Time',
  fuelHistoryTitle: 'Fuel History',
  fuelNotePlaceholder: 'Note: Refilled / Fuel used...',
  walletLowRecharge: 'Wallet balance low — recharge recommended before next booking',
  recentLabel: 'Recent',
  policyLabel: 'Policy',
  supportPolicyBooking: 'Wallet-only advance. No cash on site.',
  supportPolicyCancellation: '1-hour penalty; balance credited to wallet.',
  supportPolicyContact: 'Use DE Support only — direct operator contact prohibited.',
  supportPolicyGst: '18% GST on all invoices; download from Reports tab.',
  supportPolicyHours: 'Mon–Sat, 9 AM – 7 PM IST',
  machineDefaultLabel: 'Machine',
  assignedOperator: 'Assigned Operator',
  machineDetailsTitle: 'Machine Details',
  bookingTypeLabel: 'Booking Type',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  walletRechargeRazorpayTitle: 'Wallet Recharge',
  walletRechargeRazorpayHint: 'Use Pay Now — Razorpay checkout credits your wallet automatically. NEFT/IMPS bank transfer is not supported in-app.',
  selectPaymentMethodHint: 'UPI/Card/Net Banking from ₹1 (test). NEFT/IMPS min ₹5,000.',
  walletRechargeMinHint: '₹1 test: use Card if UPI QR fails. Bank transfer min ₹5,000.',
  upiQrSmallAmountHint: 'For ₹1–10, Card tab is more reliable than UPI QR.',
  walletPaymentsBuildTag: 'Wallet layout v3 — tablet stack',
  walletLoginRequired: 'Session expired. Please log out and sign in again.',
  ownerPayoutWallet: 'Payout Wallet',
  ownerPayoutWalletBalance: 'PAYOUT WALLET BALANCE',
  ownerPayoutWalletHint: 'Rent/settlement from Development Express is credited here (not client advance wallet). Balance ₹0 until admin records a payout.',
  ownerPayoutHowTitle: 'How owner payouts work',
  ownerPayoutHow1: 'Client pays advance via Client Wallet → Razorpay (separate from this wallet).',
  ownerPayoutHow2: 'After booking settlement, Admin credits your Payout Wallet (NEFT/RTGS + ledger entry).',
  ownerPayoutHow3: 'Subscription plans (future) will debit this wallet or bill separately — not built yet.',
  ownerPayoutTxnTitle: 'Payout ledger',
  ownerPayoutTxnEmpty: 'No payouts yet. Contact DE accounts after your machines complete billed work.',
  ownerPayoutCredit: 'Credit (payout)',
  ownerPayoutDebit: 'Debit',
  ownerPayoutLedgerYear: 'Year',
  ownerPayoutLedgerMonth: 'Month',
  ownerPayoutOpening: 'Opening Balance',
  ownerPayoutClosing: 'Closing Balance',
  ownerPayoutCreditsTotal: 'Total Credits',
  ownerPayoutDebitsTotal: 'Total Debits',
  ownerPayoutNoTxnsInPeriod: 'No transactions in this period',
  ownerPayoutDownloadLedger: 'Download Ledger PDF',
  ownerReportsDemoNotice: 'Sample report below is demo UI. Live rent payouts appear under Payout Wallet tab.',
  ownerTotalEarned: 'Total Earned',
  ownerThisMonth: 'This Month',
  ownerPendingSettlements: 'Pending',
  ownerSettlementsEmpty: 'No settlements yet. Completed bookings will appear here after admin settlement.',
  ownerSettlementsLoadError: 'Unable to load settlements — try again.',
  ownerBookingRef: 'Booking Ref',
  ownerSettlementSettled: 'Settled',
  ownerSettlementPending: 'Pending transfer',
  ownerSettlementFailed: 'Failed',
  ownerProfileIncomplete: 'Profile incomplete — update your name in account settings before downloading receipt.',
  ownerReceiptPdf: 'Receipt',
  ownerReceiptGenerating: 'Generating…',
  ownerNoPaymentsYet: 'No payments yet',
  ownerViewAllPayments: 'View all',
  ownerRecentPayments: 'Recent Payments',
  ownerSettings: 'Settings',
  ownerHubMachinesSubtitle: 'View and manage your equipment',
  ownerHubRegisterSubtitle: 'Add new equipment to platform',
  ownerHubEditRegistrationSubtitle: 'Update your machine details',
  ownerHubWalletSubtitle: 'View balance and payouts',
  ownerHubReportsSubtitle: 'Monthly booking reports',
  ownerHubAnalyticsSubtitle: 'Performance and earnings',
  ownerHubRecoverySubtitle: 'Investment recovery timeline and ROI',
  ownerHubOperatorsSubtitle: 'Manage your operators',
  ownerHubTrackingSubtitle: 'Live machine location',
  ownerHubKycSubtitle: 'Complete your identity check',
  ownerHubSettingsSubtitle: 'Profile and preferences',
  ownerHubAlertsSubtitle: 'Booking and payment alerts',
  ownerHubNotificationsSubtitle: 'Platform notifications',
  ownerHubTermsSubtitle: 'Platform terms and policies',
  ownerHubSupportSubtitle: 'Help and contact us',
  ownerBankTaxDetails: 'Bank & Tax Details',
  ownerBankTaxHint: 'Required for PDF receipts and NEFT payouts. Account/PAN shown masked here.',
  ownerAccountHolderName: 'Account Holder Name',
  ownerBankName: 'Bank Name',
  ownerPanNumber: 'PAN Number',
  ownerProfileSaved: 'Bank & tax details saved.',
  ownerEditProfile: 'Edit',
  ownerSaveProfile: 'Save',
  ownerCancelEdit: 'Cancel',
  ownerPaymentReceivedTitle: 'Payment received',
  ownerPaymentReceivedBody: 'Gross billing ₹{gross} recorded. Net to your wallet: ₹{net}.',
  ownerPaymentPendingWallet: 'Net payout pending — DE treasury will credit your Payout Wallet shortly.',
  ownerMarkWorkComplete: 'Mark work complete',
  ownerWorkCompleting: 'Completing…',
  ownerWithdrawTitle: 'Withdraw to bank',
  ownerWithdrawAmount: 'Amount (₹)',
  ownerWithdrawSubmit: 'Request withdraw',
  ownerWithdrawSubmitted: 'Withdraw request submitted. Paid after admin NEFT (1–3 days).',
  ownerWithdrawMin: 'Minimum ₹1,000',
  gstInvoiceAfterComplete: 'GST invoice unlocks after booking is marked Completed.',
  razorpayMethodOpenHint: 'Opens Razorpay checkout for',
  pleaseWait: 'Please wait…',
  upiQrFailed: 'UPI QR failed. Try Card tab or enable QR Codes in Razorpay Dashboard.',
  upiQrNotEnabledOnMerchant: 'Razorpay QR Codes is not enabled on your merchant account. Use Card / Net Banking, or ask Razorpay support to enable QR Codes.',
  upiQrUseCardForSmallAmounts: 'For ₹1–10 test, use the Card tab. UPI QR is not suitable for small test amounts.',
  referenceQrTitle: 'Reference QR (optional)',
  upiQrNoAutoCredit: 'Scanning this QR does not credit your wallet. Use Pay Now for instant balance update.',
  razorpayMethodsHint: 'Available in Razorpay checkout after Pay Now (per your merchant settings):',
  rechargeCustomPlaceholder: 'Amount (from ₹1 for UPI/Card)',
  upiQrTabLabel: 'UPI QR',
  dynamicUpiQrTitle: 'Scan to pay (Razorpay)',
  dynamicUpiQrPrompt: 'Enter amount and generate a one-time UPI QR.',
  generateUpiQr: 'Generate UPI QR',
  dynamicUpiQrHint: 'Valid 30 minutes. Wallet credits automatically after payment.',
  bankTransferTitle: 'Bank transfer details',
  bankTransferUnavailable: 'NEFT/IMPS recharge is not configured. Use Pay Now or UPI QR.',
  bankUtrPlaceholder: 'UTR / reference number (8–22 characters)',
  submitBankTransfer: 'Submit transfer for verification',
  bankTransferSubmitted: 'Transfer submitted. Wallet will be credited after admin verification (usually within 24h).',
  bankTransferFailed: 'Could not submit transfer request.',
  bankTransferPendingHint: 'Submit only after you have completed the bank transfer for the exact amount above.',
  marketingBuiltFor: 'built for Indian construction teams who demand precision, compliance, and speed.',
  policyTopicBooking: 'Booking',
  policyTopicCancellation: 'Cancellation',
  policyTopicContact: 'Contact',
  policyTopicGst: 'GST',
  policyTopicHours: 'Support Hours',
  rechargePlus: '+ Recharge',
  blacklistWarnClientMachine: 'Client and Machine will be Blacklisted',
  blacklistWarnBookingsCancelled: 'All Bookings will be Cancelled',
  blacklistWarnWalletFrozen: 'Wallet Balance will be Frozen',
  blacklistWarnLegalAction: 'Legal Action will be taken',
  issueDescribePlaceholder: 'Describe the issue in detail...',
  operatorFullNamePlaceholder: 'Operator full name',
  minPasswordPlaceholder: 'Min 8 characters',
  tableBase: 'Base',
  tableGst: 'GST',
  invoiceCol: 'Invoice',
  processingLabel: 'Processing…',
  confirmAdvanceLabel: 'Advance',
  confirmWalletAfterLabel: 'Wallet After',
  closeMenuAria: 'Close menu',
  fuelNoteRefilledPlaceholder: 'Note: Refilled 50 Ltrs...',
  surveySelectRole: 'Select your role',
  surveyWhoAreYou: 'Who are you?',
  surveyChooseOne: 'Choose one option to continue.',
  surveyOwnerTitle: 'Machine Owner',
  surveyOwnerSubtitle: 'Fleet owner · JCB / excavator',
  surveyClientNeedTitle: 'I Need a Machine',
  surveyClientNeedSubtitle: 'Hire equipment for your project',
  surveyPmTitle: 'Project Manager',
  surveyPmSubtitle: 'Construction company · contractor firm',
  surveyContractorTitle: 'Independent Contractor',
  surveyContractorSubtitle: 'Runs your own project',
};

const MR = {
  availableNow: 'आता उपलब्ध',
  avgRating: 'सरासरी रेटिंग',
  advancePaid: 'अग्रिम भरले',
  quantityLabel: 'प्रमाण',
  currentlyDeployed: 'सध्या डिप्लॉय',
  liveMachineLocation: 'लाइव्ह मशीन स्थान',
  quickRechargeUpi: 'UPI द्वारे जलद रिचार्ज',
  scanToPay: 'पेमेंटसाठी स्कॅन करा',
  quickSelect: 'जलद निवड:',
  filterAll: 'सर्व',
  filterCredit: 'क्रेडिट',
  filterDebit: 'डेबिट',
  txnDescription: 'वर्णन',
  noTransactionsFilter: 'निवडलेल्या फिल्टरसाठी व्यवहार नाहीत.',
  noBookingsAccount: 'या खात्यासाठी अजून बुकिंग नाही.',
  invoiceNotAvailableCancelled: 'इन्व्हॉइस उपलब्ध नाही (रद्द)',
  noAlertsNow: 'सध्या अलर्ट नाहीत.',
  pushNotificationsTitle: 'पुश सूचना',
  pushNotificationsHint: 'बुकिंग आणि अपडेटसाठी ब्राउझर अलर्ट. WhatsApp वेगळा आहे.',
  pushStatusOn: 'पुश सूचना ON',
  pushStatusOff: 'पुश सूचना OFF',
  pushEnabledNote: 'सुरू — ब्राउझर permission विचारल्यास Allow करा.',
  pushEnablePrompt: 'त्वरित अपडेटसाठी पुश सूचना सुरू करा',
  downloadDisputeStatement: 'विवाद विधान डाउनलोड करा',
  downloadInvoice: 'इनव्हॉइस डाउनलोड करा',
  bookAgain: 'पुन्हा बुक करा',
  machineNoLongerAvailable: 'मशीन आता उपलब्ध नाही',
  downloadHistoryPdf: 'इतिहास PDF डाउनलोड करा',
  pushDisabledNote: 'बंद — या डिव्हाइसवर पुश अलर्ट येणार नाहीत.',
  pushBrowserBlocked: 'ब्राउझरने notifications ब्लॉक केले. साइट सेटिंग्जमध्ये Allow करा.',
  pushPrefLoadFailed: 'सूचना प्राधान्य लोड होऊ शकले नाही.',
  pushPrefUpdateFailed: 'सूचना प्राधान्य अपडेट होऊ शकले नाही.',
  pushMigrationRequired: 'DB migration बाकी — Supabase मध्ये push_notifications migration run करा.',
  walletRechargeRequired: 'वॉलेटमध्ये ₹{amount} पाहिजे. कृपया रिचार्ज करा.',
  confirmPayBalancePrompt: 'बाकी ₹{amount} पुष्टी करून पे करायचे?',
  bookingExtensionFailed: 'एक्सटेंशन अयशस्वी',
  bookingConfirmFailed: 'पुष्टी अयशस्वी',
  bookingDisputeFailed: 'वाद अयशस्वी',
  sessionExpiredLogin: 'सेशन संपला! पुन्हा लॉगिन करा.',
  sessionExpireWarning: '५ मिनिटांत सेशन संपेल. कृपया सक्रिय राहा.',
  walletCreditedAlert: '₹{amount} वॉलेटमध्ये add झाले!{payLine}',
  bookingsCount: '{count} बुकिंग',
  transactionsCount: '{count} व्यवहार',
  txnDayNet: 'दैनिक नेट',
  pendingCount: '{count} प्रलंबित',
  directContactBlacklist: 'थेट संपर्क = ब्लॅकलिस्ट',
  pdfInvoiceFailed: 'इन्व्हॉइस PDF तयार करता आला नाही. पुन्हा प्रयत्न करा.',
  pdfReportFailed: 'अहवाल PDF तयार करता आला नाही. पुन्हा प्रयत्न करा.',
  bookingFailedGeneric: 'बुकिंग अयशस्वी. पुन्हा प्रयत्न करा.',
  useSavedAddress: 'जतन केलेला पत्ता वापरा',
  machineIdLabel: 'मशीन ID',
  yearsExperience: '{n} वर्षे',
  fuelColon: 'इंधन:',
  hrsUnit: 'तास',
  daysUnit: 'दिवस',
  wksUnit: 'आठवडे',
  moUnit: 'महिने',
  walletDebit: 'वॉलेट डेबिट',
  statusCancelled: 'रद्द',
  statusCompleted: 'पूर्ण',
  naLabel: 'लागू नाही',
  loadedOwnerBookings: '{count} मालक बुकिंग लोड{suffix}',
  ownerBookingsMoreAvailable: ' (अजून उपलब्ध)',
  ownerBookingsAllLoaded: ' (सर्व लोड)',
  machineDispatchedAt: 'मशीन पाठवली — {when}',
  loginIAmQuestion: 'मी कोण…?',
  loginPickRoleHint: 'नोंदणीकृत? भूमिका निवडा. नवीन? खाली Join Us वापरा.',
  loginRoleClientDesc: 'बांधकाम प्रकल्पांसाठी मशिनरी बुक करा',
  loginRoleOwnerDesc: 'फ्लीट, कमाई आणि उपलब्धता व्यवस्थापित करा',
  loginRoleOperatorDesc: 'नियुक्त मशीन आणि दैनिक लॉग',
  loginRoleAdminDesc: 'प्लॅटफॉर्म नियंत्रण, मंजुरी आणि ऑपरेशन्स',
  loginPortalClientTitle: 'ग्राहक पोर्टल',
  loginPortalClientSubtitle: 'बांधकाम मशिनरी बुक करण्यासाठी साइन इन',
  loginPortalOwnerTitle: 'मालक पोर्टल',
  loginPortalOwnerSubtitle: 'फ्लीट आणि नोंदणी व्यवस्थापित करण्यासाठी साइन इन',
  loginPortalOperatorTitle: 'ऑपरेटर पोर्टल',
  loginPortalOperatorSubtitle: 'नियुक्त मशीन आणि दैनिक लॉगसाठी साइन इन',
  loginPortalAdminTitle: 'अॅडमिन पोर्टल',
  loginPortalAdminSubtitle: 'प्लॅटफॉर्म नियंत्रण आणि मंजुरी',
  trustStatMachines: 'मशीन',
  trustStatRating: 'रेटिंग',
  trustStatCompliant: 'अनुपालन',
  signupSectionContact: 'तुमची माहिती',
  signupSectionCompany: 'कंपनी',
  signupSectionSecurity: 'सुरक्षा',
  signupContactName: 'संपर्क नाव',
  signupCompanyName: 'कंपनीचे नाव',
  signupCreatePassword: 'पासवर्ड तयार करा',
  signupReenterPassword: 'पासवर्ड पुन्हा टाका',
  timeLabel: 'वेळ',
  fuelHistoryTitle: 'इंधन इतिहास',
  fuelNotePlaceholder: 'टीप: भरले / वापरलेले इंधन...',
  walletLowRecharge: 'वॉलेट शिल्लक कमी — पुढील बुकिंगपूर्वी रिचार्ज करा',
  recentLabel: 'अलीकडील',
  policyLabel: 'धोरण',
  supportPolicyBooking: 'फक्त वॉलेट अग्रिम. साइटवर रोख नाही.',
  supportPolicyCancellation: '१ तास दंड; शिल्लक वॉलेटमध्ये.',
  supportPolicyContact: 'फक्त DE सपोर्ट — थेट ऑपरेटर संपर्क निषिद्ध.',
  supportPolicyGst: 'सर्व इन्व्हॉइसवर १८% GST; अहवाल टॅबवरून डाउनलोड.',
  supportPolicyHours: 'सोम–शनि, ९ ते ७ IST',
  machineDefaultLabel: 'मशीन',
  assignedOperator: 'नियुक्त ऑपरेटर',
  machineDetailsTitle: 'मशीन तपशील',
  bookingTypeLabel: 'बुकिंग प्रकार',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  walletRechargeRazorpayTitle: 'वॉलेट रिचार्ज',
  walletRechargeRazorpayHint: 'Pay Now वापरा — Razorpay checkout नंतर वॉलेट आपोआप credit होते. NEFT/IMPS बँक ट्रान्सफर app मध्ये नाही.',
  selectPaymentMethodHint: 'UPI/Card/Net Banking ₹1 पासून (test). NEFT/IMPS किमान ₹5,000.',
  walletRechargeMinHint: '₹1 test: UPI QR अयशस्वी असेल तर Card वापरा. बँक किमान ₹5,000.',
  upiQrSmallAmountHint: '₹1–10 साठी Card tab अधिक विश्वासार्ह.',
  walletPaymentsBuildTag: 'Wallet payments v2',
  walletLoginRequired: 'सेशन संपला. पुन्हा लॉगिन करा.',
  ownerPayoutWallet: 'पेआउट वॉलेट',
  ownerPayoutWalletBalance: 'पेआउट वॉलेट बॅलन्स',
  ownerPayoutWalletHint: 'DE कडून भाडे/सेटलमेंट येथे credit होते. Admin payout नंतरच balance वाढते.',
  ownerPayoutHowTitle: 'Owner payout कसे',
  ownerPayoutHow1: 'Client advance वेगळ्या Client Wallet मध्ये.',
  ownerPayoutHow2: 'Settlement नंतर Admin तुमचे Payout Wallet credit करतो.',
  ownerPayoutHow3: 'Subscription (भविष्य) — अजून build नाही.',
  ownerPayoutTxnTitle: 'Payout खातेवही',
  ownerPayoutTxnEmpty: 'अजून payout नाही. DE accounts शी संपर्क करा.',
  ownerPayoutCredit: 'Credit',
  ownerPayoutDebit: 'Debit',
  ownerPayoutLedgerYear: 'वर्ष',
  ownerPayoutLedgerMonth: 'महिना',
  ownerPayoutOpening: 'प्रारंभिक शिल्लक',
  ownerPayoutClosing: 'अंतिम शिल्लक',
  ownerPayoutCreditsTotal: 'एकूण जमा',
  ownerPayoutDebitsTotal: 'एकूण निकासी',
  ownerPayoutNoTxnsInPeriod: 'या कालावधीत कोणताही व्यवहार नाही',
  ownerPayoutDownloadLedger: 'लेजर PDF डाउनलोड करा',
  ownerReportsDemoNotice: 'खालील report demo आहे. खरे payout → Payout Wallet tab.',
  ownerTotalEarned: 'एकूण मिळाले',
  ownerThisMonth: 'या महिन्यात',
  ownerPendingSettlements: 'प्रलंबित',
  ownerSettlementsEmpty: 'अजून settlement नाही. पूर्ण booking नंतर येथे दिसेल.',
  ownerSettlementsLoadError: 'लोड अयशस्वी — पुन्हा प्रयत्न करा.',
  ownerBookingRef: 'बुकिंग Ref',
  ownerSettlementSettled: 'Settled',
  ownerSettlementPending: 'Transfer प्रलंबित',
  ownerSettlementFailed: 'अयशस्वी',
  ownerProfileIncomplete: 'Profile incomplete — receipt साठी account मध्ये नाव अपडेट करा.',
  ownerReceiptPdf: 'Receipt',
  ownerReceiptGenerating: 'तयार होत आहे…',
  ownerNoPaymentsYet: 'अजून payment नाही',
  ownerViewAllPayments: 'सर्व पहा',
  ownerRecentPayments: 'अलीकडील Payments',
  ownerHubRecoverySubtitle: 'गुंतवणूक परतावा टाइमलाइन आणि ROI',
  ownerSettings: 'Settings',
  ownerBankTaxDetails: 'Bank & Tax Details',
  ownerBankTaxHint: 'PDF receipt आणि NEFT साठी आवश्यक. Account/PAN masked दिसतील.',
  ownerAccountHolderName: 'Account Holder Name',
  ownerBankName: 'Bank Name',
  ownerPanNumber: 'PAN Number',
  ownerProfileSaved: 'Bank & tax details saved.',
  ownerEditProfile: 'Edit',
  ownerSaveProfile: 'Save',
  ownerCancelEdit: 'Cancel',
  razorpayMethodOpenHint: 'Razorpay checkout उघडेल',
  pleaseWait: 'कृपया थांबा…',
  upiQrFailed: 'UPI QR अयशस्वी. Card tab वापरा किंवा Razorpay मध्ये QR Codes सक्षम करा.',
  upiQrNotEnabledOnMerchant: 'तुमच्या Razorpay खात्यावर QR Codes सक्षम नाहीत. Card / Net Banking वापरा किंवा Razorpay ला QR Codes साठी संपर्क करा.',
  upiQrUseCardForSmallAmounts: '₹1–10 test साठी Card tab वापरा. UPI QR लहान रकमेसाठी योग्य नाही.',
  referenceQrTitle: 'संदर्भ QR (ऐच्छिक)',
  upiQrNoAutoCredit: 'या QR स्कॅन केल्यावर वॉलेट credit होत नाही. त्वरित balance साठी Pay Now वापरा.',
  razorpayMethodsHint: 'Pay Now नंतर Razorpay checkout मध्ये (merchant settings नुसार):',
  rechargeCustomPlaceholder: 'रक्कम (UPI/Card ₹1 पासून)',
  upiQrTabLabel: 'UPI QR',
  dynamicUpiQrTitle: 'स्कॅन करून पे करा (Razorpay)',
  dynamicUpiQrPrompt: 'रक्कम भरा आणि एक-वेळ UPI QR तयार करा.',
  generateUpiQr: 'UPI QR तयार करा',
  dynamicUpiQrHint: '३० मिनिटे वैध. पेमेंट नंतर वॉलेट आपोआप credit.',
  bankTransferTitle: 'बँक ट्रान्सफर तपशील',
  bankTransferUnavailable: 'NEFT/IMPS कॉन्फिग नाही. Pay Now किंवा UPI QR वापरा.',
  bankUtrPlaceholder: 'UTR / reference (8–22 अक्षरे)',
  submitBankTransfer: 'पडताळणीसाठी सबमिट करा',
  bankTransferSubmitted: 'सबमिट झाले. Admin verify नंतर wallet credit (साधारण 24h).',
  bankTransferFailed: 'सबमिट अयशस्वी.',
  bankTransferPendingHint: 'वरच्या रकमेचा बँक ट्रान्सफर पूर्ण झाल्यावरच UTR सबमिट करा.',
  marketingBuiltFor: 'अचूकता, अनुपालन आणि वेग हवा असलेल्या भारतीय बांधकाम संघांसाठी.',
  policyTopicBooking: 'बुकिंग',
  policyTopicCancellation: 'रद्दीकरण',
  policyTopicContact: 'संपर्क',
  policyTopicGst: 'GST',
  policyTopicHours: 'सपोर्ट वेळ',
  rechargePlus: '+ रिचार्ज',
  blacklistWarnClientMachine: 'क्लायंट आणि मशीन ब्लॅकलिस्ट होतील',
  blacklistWarnBookingsCancelled: 'सर्व बुकिंग रद्द होतील',
  blacklistWarnWalletFrozen: 'वॉलेट शिल्लक गोठवली जाईल',
  blacklistWarnLegalAction: 'कायदेशीर कारवाई होईल',
  issueDescribePlaceholder: 'समस्या तपशीलवार लिहा...',
  operatorFullNamePlaceholder: 'ऑपरेटरचे पूर्ण नाव',
  minPasswordPlaceholder: 'किमान 8 अक्षरे',
  tableBase: 'बेस',
  tableGst: 'GST',
  invoiceCol: 'इन्व्हॉइस',
  processingLabel: 'प्रोसेस होत आहे…',
  confirmAdvanceLabel: 'अग्रिम',
  confirmWalletAfterLabel: 'उरलेले वॉलेट',
  closeMenuAria: 'मेनू बंद करा',
  fuelNoteRefilledPlaceholder: 'टीप: 50 लिटर भरले...',
  bf2AwaitingDispatch: 'Booking confirm zali. Dispatch approval baki ahe.',
  bf2OwnerApprovedSoon: 'Owner ne approve kela — machine lवकरच suru hoil.',
  bf2Active: 'ACTIVE',
  bf2MachineHoursLive: 'Machine Hours (Live)',
  bf2Booked: 'Booked',
  bf2Remaining: 'Remaining',
  bf2RunningBill: 'Chalti Bill',
  bf2Outstanding: 'Baki Amount',
  bf2MinimumBilling: 'Minimum {hours} hrs billing laagu ahe (₹{amount})',
  bf2AdvancePaid: 'Advance Paid',
  bf2Started: 'Suru',
  bf2ExtendHr: '+ {hours} hrs Vadhva',
  bf2ExtendConfirm: '{hours} hrs vadhvaychya?\n\nEkun: ₹{total}\nAdvance (50%): ₹{advance}\n\nWallet madun ₹{advance} cut hoil.',
  bf2ExtendSuccess: '✅ {hours} hrs vadhle!\n₹{advance} wallet madun cut zale.',
  bf2ExtensionPending: 'Extension maagitli. Pudhye chalnyasathi advance bhara.',
  bf2ConfirmWorkComplete: 'Kaam Poorn Confirm Kara',
  bf2OperatorLogged: 'Operator ne log kele: {logged} hrs · Minimum: {min} hrs · Charge: {final} hrs',
  bf2BalanceDue: 'Baki Rakam: ₹{amount} (wallet)',
  bf2Deadline: 'Deadline: {time} baaki',
  bf2ConfirmPayBtn: 'Confirm & Pay ₹{amount}',
  bf2Dispute: 'Takar',
  bf2DisputePlaceholder: 'Hours chukicha aahe karan...',
  bf2SubmitDispute: 'Takar Pathva',
  bf2DisputeRaised: 'Takar nondavli. Admin review karat aahe.',
  bf2CompletedSummary: 'Ekun: ₹{total} · Advance: ₹{advance}',
  bf2CompletedHours: ' · {hours} hrs',
  bf2ActualWorkRequired: 'Pratyaksh kam vel (HH:MM:SS)',
  bf2LogWorkConfirm: 'Booking #{ref} sathi {time} ({hours} hrs) log karaysacha? Client la kळavle jaaeel.',
  bf2MarkCompleteFailed: 'Poorn mark karne failed',
  etaOwnerApproval: 'Malakachya manjurichi vaat pahat aahe',
  etaWorkInProgress: 'Andajit poorn honarachi vel',
  etaPaymentDeadline: 'Payment pushtikaranachi antim mudat',
  etaWorkCompleted: 'Kaam poorn jhale',
  etaDisputeReview: 'DE team vadache punaravlokan karat aahe',
  etaMinutesRemaining: '{n} minute baaki',
  etaHoursRemaining: '{n} tas baaki',
  activeBookingWarning: 'या मशीनवर आधीच बुकिंग active आहे (#{{ref}}). नवीन बुकिंगपूर्वी ती पूर्ण करा.',
  gstInvoiceAfterComplete: 'बुकिंग Completed झाल्यावर GST invoice उपलब्ध होईल.',
  navigateToSite: '🗺️ साइटकडे नेव्हिगेट करा',
  openInMaps: '📍 Maps मध्ये उघडा',
  ownerHubAlertsSubtitle: 'बुकिंग आणि पेमेंट अलर्ट',
  ownerHubAnalyticsSubtitle: 'कामगिरी आणि कमाई',
  ownerHubEditRegistrationSubtitle: 'तुमचे मशीन तपशील अपडेट करा',
  ownerHubKycSubtitle: 'ओळख पडताळणी पूर्ण करा',
  ownerHubMachinesSubtitle: 'तुमची उपकरणे पहा आणि व्यवस्थापित करा',
  ownerHubNotificationsSubtitle: 'सूचना प्राधान्ये',
  ownerHubOperatorsSubtitle: 'ऑपरेटर व्यवस्थापन',
  ownerHubRegisterSubtitle: 'नवीन मशीन नोंदणी',
  ownerHubReportsSubtitle: 'कमाई अहवाल',
  ownerHubSettingsSubtitle: 'खाते सेटिंग्ज',
  ownerHubSupportSubtitle: 'मदत आणि सपोर्ट',
  ownerHubTermsSubtitle: 'सेवा अटी',
  ownerHubTrackingSubtitle: 'मशीन ट्रॅकिंग',
  ownerHubWalletSubtitle: 'पेआउट वॉलेट',
  ownerMarkWorkComplete: 'काम पूर्ण म्हणून चिन्हांकित करा',
  ownerPaymentPendingWallet: 'निव्वळ पेआउट प्रलंबित — DE treasury लवकरच तुमच्या Payout Wallet मध्ये credit करेल.',
  ownerPaymentReceivedBody: '₹{gross} चे एकूण बिलिंग नोंदवले. तुमच्या वॉलेटमध्ये निव्वळ: ₹{net}.',
  ownerPaymentReceivedTitle: 'पेमेंट मिळाले',
  ownerWithdrawAmount: 'रक्कम (₹)',
  ownerWithdrawMin: 'किमान ₹1,000',
  ownerWithdrawSubmit: 'निकासी विनंती करा',
  ownerWithdrawSubmitted: 'निकासी विनंती सबमिट झाली. Admin NEFT नंतर भरणा (1-3 दिवस).',
  ownerWithdrawTitle: 'बँकेत निकासी',
  ownerWorkCompleting: 'पूर्ण होत आहे…',
  siteAddressLabel: 'साइट पत्ता',
  siteGpsDenied: 'स्थान परवानगी नाकारली. पत्ता मॅन्युअल टाका किंवा GPS सक्षम करा.',
  siteGpsLoading: 'स्थान मिळवत आहे…',
  siteGpsUnavailable: 'GPS उपलब्ध नाही. पत्ता मॅन्युअल टाका.',
  siteLocationOptional: 'ऐच्छिक — ऑपरेटरला साइट लवकर सापडण्यास मदत होते.',
  siteLocationTitle: 'साइट स्थान',
  sitePincodeLabel: 'पिनकोड',
  surveyQrBlockConfirm: 'फ्रीलांसर {code} ला block करायचे? त्यांचा referral link लगेच बंद होईल.',
  surveyQrBlockFreelancer: 'Block करा',
  surveyQrFreelancerBlocked: 'Blocked: {code} — referral link अक्षम.',
  surveyQrFreelancerStatus: 'स्थिती',
  surveyQrFreelancerUnblocked: 'Unblocked: {code} — referral link सक्रिय.',
  surveyQrStatusActive: 'सक्रिय',
  surveyQrStatusBlocked: 'Blocked',
  surveyQrUnblockConfirm: 'फ्रीलांसर {code} ला unblock करा आणि त्यांचा referral link पुन्हा सक्षम करा?',
  surveyQrUnblockFreelancer: 'Unblock करा',
  surveySelectRole: 'तुमची भूमिका निवडा',
  surveyWhoAreYou: 'तुम्ही कोण आहात?',
  surveyChooseOne: 'पुढे जाण्यासाठी एक पर्याय निवडा.',
  surveyOwnerTitle: 'मशीन मालक',
  surveyOwnerSubtitle: 'फ्लीट मालक · JCB / एक्स्कॅव्हेटर',
  surveyClientNeedTitle: 'मला मशीन हवी आहे',
  surveyClientNeedSubtitle: 'तुमच्या प्रकल्पासाठी मशीन भाड्याने घ्या',
  surveyPmTitle: 'प्रोजेक्ट मॅनेजर',
  surveyPmSubtitle: 'कन्स्ट्रक्शन कंपनी · कॉन्ट्रॅक्टर फर्म',
  surveyContractorTitle: 'स्वतंत्र कॉन्ट्रॅक्टर',
  surveyContractorSubtitle: 'स्वतःचा प्रोजेक्ट चालवता',
  useCurrentLocation: '📍 सध्याचे स्थान वापरा',
};

const HI = {
  availableNow: 'अभी उपलब्ध',
  avgRating: 'औसत रेटिंग',
  advancePaid: 'अग्रिम भुगतान',
  quantityLabel: 'मात्रा',
  currentlyDeployed: 'वर्तमान में तैनात',
  liveMachineLocation: 'लाइव मशीन स्थान',
  quickRechargeUpi: 'UPI से त्वरित रिचार्ज',
  scanToPay: 'भुगतान के लिए स्कैन करें',
  quickSelect: 'त्वरित चयन:',
  filterAll: 'सभी',
  filterCredit: 'क्रेडिट',
  filterDebit: 'डेबिट',
  txnDescription: 'विवरण',
  noTransactionsFilter: 'चयनित फ़िल्टर के लिए कोई लेनदेन नहीं।',
  noBookingsAccount: 'इस खाते के लिए अभी तक कोई बुकिंग नहीं।',
  invoiceNotAvailableCancelled: 'इनवॉइस उपलब्ध नहीं (रद्द)',
  noAlertsNow: 'अभी कोई अलर्ट नहीं।',
  pushNotificationsTitle: 'पुश सूचनाएँ',
  pushNotificationsHint: 'बुकिंग और अपडेट के लिए ब्राउज़र अलर्ट। WhatsApp अलग है।',
  pushStatusOn: 'पुश सूचनाएँ ON',
  pushStatusOff: 'पुश सूचनाएँ OFF',
  pushEnabledNote: 'चालू — ब्राउज़र permission माँगे तो Allow करें।',
  pushEnablePrompt: 'तुरंत अपडेट के लिए पुश सूचनाएँ चालू करें',
  downloadDisputeStatement: 'विवाद बयान डाउनलोड करें',
  downloadInvoice: 'इनवॉइस डाउनलोड करें',
  bookAgain: 'फिर से बुक करें',
  machineNoLongerAvailable: 'मशीन अब उपलब्ध नहीं है',
  downloadHistoryPdf: 'इतिहास PDF डाउनलोड करें',
  pushDisabledNote: 'बंद — इस डिवाइस पर पुश अलर्ट नहीं मिलेंगे।',
  pushBrowserBlocked: 'ब्राउज़र ने notifications ब्लॉक किए। साइट सेटिंग में Allow करें।',
  pushPrefLoadFailed: 'सूचना प्राथमिकता लोड नहीं हो सकी।',
  pushPrefUpdateFailed: 'सूचना प्राथमिकता अपडेट नहीं हो सकी।',
  pushMigrationRequired: 'DB migration बाकी — Supabase में push_notifications migration चलाएँ।',
  walletRechargeRequired: 'वॉलेट में ₹{amount} चाहिए। कृपया रिचार्ज करें।',
  confirmPayBalancePrompt: 'बाकी ₹{amount} की पुष्टि करके भुगतान करें?',
  bookingExtensionFailed: 'एक्सटेंशन विफल',
  bookingConfirmFailed: 'पुष्टि विफल',
  bookingDisputeFailed: 'विवाद विफल',
  sessionExpiredLogin: 'सेशन समाप्त! फिर से लॉगिन करें।',
  sessionExpireWarning: '५ मिनट में सेशन समाप्त होगा। कृपया सक्रिय रहें।',
  walletCreditedAlert: '₹{amount} वॉलेट में जोड़ा गया!{payLine}',
  bookingsCount: '{count} बुकिंग',
  pendingCount: '{count} लंबित',
  directContactBlacklist: 'सीधा संपर्क = ब्लैकलिस्ट',
  pdfInvoiceFailed: 'इनवॉइस PDF नहीं बन सका। पुनः प्रयास करें।',
  pdfReportFailed: 'रिपोर्ट PDF नहीं बन सका। पुनः प्रयास करें।',
  bookingFailedGeneric: 'बुकिंग विफल। पुनः प्रयास करें।',
  useSavedAddress: 'सहेजा हुआ पता उपयोग करें',
  machineIdLabel: 'मशीन ID',
  yearsExperience: '{n} वर्ष',
  fuelColon: 'ईंधन:',
  hrsUnit: 'घंटे',
  daysUnit: 'दिन',
  wksUnit: 'सप्ताह',
  moUnit: 'महीने',
  walletDebit: 'वॉलेट डेबिट',
  statusCancelled: 'रद्द',
  statusCompleted: 'पूर्ण',
  naLabel: 'लागू नहीं',
  loadedOwnerBookings: '{count} मालिक बुकिंग लोड{suffix}',
  ownerBookingsMoreAvailable: ' (और उपलब्ध)',
  ownerBookingsAllLoaded: ' (सभी लोड)',
  machineDispatchedAt: 'मशीन भेजी गई — {when}',
  loginIAmQuestion: 'मैं कौन…?',
  loginPickRoleHint: 'पंजीकृत? भूमिका चुनें। नए हैं? नीचे Join Us।',
  loginRoleClientDesc: 'निर्माण परियोजनाओं के लिए मशीनरी बुक करें',
  loginRoleOwnerDesc: 'फ्लीट, कमाई और उपलब्धता प्रबंधित करें',
  loginRoleOperatorDesc: 'नियुक्त मशीन और दैनिक लॉग',
  loginRoleAdminDesc: 'प्लेटफ़ॉर्म नियंत्रण, अनुमोदन और संचालन',
  loginPortalClientTitle: 'क्लाइंट पोर्टल',
  loginPortalClientSubtitle: 'निर्माण मशीनरी बुक करने के लिए साइन इन',
  loginPortalOwnerTitle: 'मालिक पोर्टल',
  loginPortalOwnerSubtitle: 'फ्लीट और पंजीकरण प्रबंधित करने के लिए साइन इन',
  loginPortalOperatorTitle: 'ऑपरेटर पोर्टल',
  loginPortalOperatorSubtitle: 'नियुक्त मशीन और दैनिक लॉग के लिए साइन इन',
  loginPortalAdminTitle: 'एडमिन पोर्टल',
  loginPortalAdminSubtitle: 'प्लेटफ़ॉर्म नियंत्रण और अनुमोदन',
  trustStatMachines: 'मशीन',
  trustStatRating: 'रेटिंग',
  trustStatCompliant: 'अनुपालन',
  signupSectionContact: 'आपका विवरण',
  signupSectionCompany: 'कंपनी',
  signupSectionSecurity: 'सुरक्षा',
  signupContactName: 'संपर्क नाम',
  signupCompanyName: 'कंपनी का नाम',
  signupCreatePassword: 'पासवर्ड बनाएं',
  signupReenterPassword: 'पासवर्ड दोबारा दर्ज करें',
  timeLabel: 'समय',
  fuelHistoryTitle: 'ईंधन इतिहास',
  fuelNotePlaceholder: 'नोट: भरा / उपयोग ईंधन...',
  walletLowRecharge: 'वॉलेट शेष कम — अगली बुकिंग से पहले रिचार्ज करें',
  recentLabel: 'हाल का',
  policyLabel: 'नीति',
  supportPolicyBooking: 'केवल वॉलेट अग्रिम। साइट पर नकद नहीं।',
  supportPolicyCancellation: '1 घंटे का जुर्माना; शेष वॉलेट में।',
  supportPolicyContact: 'केवल DE सपोर्ट — सीधा ऑपरेटर संपर्क वर्जित।',
  supportPolicyGst: 'सभी इनवॉइस पर 18% GST; रिपोर्ट टैब से डाउनलोड।',
  supportPolicyHours: 'सोम–शनि, 9–7 IST',
  machineDefaultLabel: 'मशीन',
  assignedOperator: 'नियुक्त ऑपरेटर',
  machineDetailsTitle: 'मशीन विवरण',
  bookingTypeLabel: 'बुकिंग प्रकार',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  walletRechargeRazorpayTitle: 'वॉलेट रिचार्ज',
  walletRechargeRazorpayHint: 'Pay Now उपयोग करें — Razorpay checkout के बाद वॉलेट स्वतः क्रेडिट होता है। NEFT/IMPS बैंक ट्रांसफर ऐप में नहीं है।',
  selectPaymentMethodHint: 'UPI/Card/Net Banking ₹1 से (test). NEFT/IMPS न्यूनतम ₹5,000।',
  walletRechargeMinHint: '₹1 test: UPI QR fail हो तो Card टैब। बैंक न्यूनतम ₹5,000।',
  upiQrSmallAmountHint: '₹1–10 के लिए Card टैब बेहतर।',
  walletPaymentsBuildTag: 'Wallet payments v2',
  walletLoginRequired: 'सेशन समाप्त। फिर से लॉगिन करें।',
  ownerPayoutWallet: 'पेआउट वॉलेट',
  ownerPayoutWalletBalance: 'पेआउट वॉलेट बैलेंस',
  ownerPayoutWalletHint: 'DE से किराया/सेटलमेंट यहाँ क्रेडिट होता है। Admin payout के बाद बैलेंस बढ़ेगा।',
  ownerPayoutHowTitle: 'Owner payout कैसे',
  ownerPayoutHow1: 'Client advance अलग Client Wallet में।',
  ownerPayoutHow2: 'Settlement के बाद Admin Payout Wallet क्रेडिट करता है।',
  ownerPayoutHow3: 'Subscription (भविष्य) — अभी नहीं।',
  ownerPayoutTxnTitle: 'Payout लेजर',
  ownerPayoutTxnEmpty: 'अभी कोई payout नहीं। DE accounts से संपर्क करें।',
  ownerPayoutCredit: 'क्रेडिट',
  ownerPayoutDebit: 'डेबिट',
  ownerPayoutLedgerYear: 'वर्ष',
  ownerPayoutLedgerMonth: 'महीना',
  ownerPayoutOpening: 'प्रारंभिक शेष',
  ownerPayoutClosing: 'समापन शेष',
  ownerPayoutCreditsTotal: 'कुल जमा',
  ownerPayoutDebitsTotal: 'कुल निकासी',
  ownerPayoutNoTxnsInPeriod: 'इस अवधि में कोई लेनदेन नहीं',
  ownerPayoutDownloadLedger: 'लेजर PDF डाउनलोड करें',
  ownerReportsDemoNotice: 'नीचे की रिपोर्ट डेमो है। असली payout → Payout Wallet टैब।',
  ownerTotalEarned: 'कुल कमाई',
  ownerThisMonth: 'इस महीने',
  ownerPendingSettlements: 'लंबित',
  ownerSettlementsEmpty: 'अभी कोई settlement नहीं। पूर्ण booking के बाद यहाँ दिखेगा।',
  ownerSettlementsLoadError: 'लोड नहीं हो सका — पुनः प्रयास करें।',
  ownerBookingRef: 'बुकिंग Ref',
  ownerSettlementSettled: 'Settled',
  ownerSettlementPending: 'Transfer लंबित',
  ownerSettlementFailed: 'विफल',
  ownerProfileIncomplete: 'Profile incomplete — receipt के लिए account में नाम अपडेट करें।',
  ownerReceiptPdf: 'Receipt',
  ownerReceiptGenerating: 'तैयार हो रहा है…',
  ownerNoPaymentsYet: 'अभी कोई payment नहीं',
  ownerViewAllPayments: 'सभी देखें',
  ownerRecentPayments: 'हाल की Payments',
  ownerHubRecoverySubtitle: 'निवेश वसूली समयरेखा और ROI',
  ownerSettings: 'Settings',
  ownerBankTaxDetails: 'Bank & Tax Details',
  ownerBankTaxHint: 'PDF receipt और NEFT के लिए आवश्यक। Account/PAN masked दिखेगा।',
  ownerAccountHolderName: 'Account Holder Name',
  ownerBankName: 'Bank Name',
  ownerPanNumber: 'PAN Number',
  ownerProfileSaved: 'Bank & tax details saved.',
  ownerEditProfile: 'Edit',
  ownerSaveProfile: 'Save',
  ownerCancelEdit: 'Cancel',
  razorpayMethodOpenHint: 'Razorpay checkout खुलेगा',
  pleaseWait: 'कृपया प्रतीक्षा करें…',
  upiQrFailed: 'UPI QR विफल। Card टैब करें या Razorpay में QR Codes सक्षम करें।',
  upiQrNotEnabledOnMerchant: 'आपके Razorpay खाते पर QR Codes सक्षम नहीं हैं। Card / Net Banking उपयोग करें या Razorpay से QR Codes चालू करवाएं।',
  upiQrUseCardForSmallAmounts: '₹1–10 test के लिए Card टैब उपयोग करें।',
  referenceQrTitle: 'संदर्भ QR (वैकल्पिक)',
  upiQrNoAutoCredit: 'इस QR स्कैन से वॉलेट क्रेडिट नहीं होता। तुरंत बैलेंस के लिए Pay Now करें।',
  razorpayMethodsHint: 'Pay Now के बाद Razorpay checkout में (merchant settings के अनुसार):',
  rechargeCustomPlaceholder: 'राशि (UPI/Card ₹1 से)',
  upiQrTabLabel: 'UPI QR',
  dynamicUpiQrTitle: 'स्कैन करके भुगतान (Razorpay)',
  dynamicUpiQrPrompt: 'राशि दर्ज करें और एक बार का UPI QR बनाएं।',
  generateUpiQr: 'UPI QR बनाएं',
  dynamicUpiQrHint: '30 मिनट वैध। भुगतान के बाद वॉलेट स्वतः क्रेडिट।',
  bankTransferTitle: 'बैंक ट्रांसफर विवरण',
  bankTransferUnavailable: 'NEFT/IMPS कॉन्फ़िग नहीं। Pay Now या UPI QR उपयोग करें।',
  bankUtrPlaceholder: 'UTR / reference (8–22 अक्षर)',
  submitBankTransfer: 'सत्यापन के लिए सबमिट करें',
  bankTransferSubmitted: 'सबमिट हो गया। Admin verify के बाद wallet credit (आमतौर 24h)।',
  bankTransferFailed: 'सबमिट विफल।',
  bankTransferPendingHint: 'ऊपर की राशि का बैंक ट्रांसफर पूरा होने के बाद UTR सबमिट करें।',
  marketingBuiltFor: 'सटीकता, अनुपालन और गति चाहने वाली भारतीय निर्माण टीमों के लिए।',
  policyTopicBooking: 'बुकिंग',
  policyTopicCancellation: 'रद्दीकरण',
  policyTopicContact: 'संपर्क',
  policyTopicGst: 'GST',
  policyTopicHours: 'सपोर्ट समय',
  bf2AwaitingDispatch: 'Booking confirm ho gayi. Dispatch approval baki hai.',
  bf2OwnerApprovedSoon: 'Owner ne approve kiya — machine jald shuru hogi.',
  bf2Active: 'ACTIVE',
  bf2MachineHoursLive: 'Machine Hours (Live)',
  bf2Booked: 'Booked',
  bf2Remaining: 'Baaki',
  bf2RunningBill: 'Chal Raha Bill',
  bf2Outstanding: 'Baaki Rakam',
  bf2MinimumBilling: 'Minimum {hours} hrs billing laagu hai (₹{amount})',
  bf2AdvancePaid: 'Advance Paid',
  bf2Started: 'Shuru',
  bf2ExtendHr: '+ {hours} hrs Badhao',
  bf2ExtendConfirm: '{hours} hrs badhana hai?\n\nKul: ₹{total}\nAdvance (50%): ₹{advance}\n\nWallet se ₹{advance} katega.',
  bf2ExtendSuccess: '✅ {hours} hrs badh gaye!\n₹{advance} wallet se kata.',
  bf2ExtensionPending: 'Extension maangi. Aage ke liye advance bharein.',
  bf2ConfirmWorkComplete: 'Kaam Poora Confirm Karein',
  bf2OperatorLogged: 'Operator ne log kiya: {logged} hrs · Minimum: {min} hrs · Charge: {final} hrs',
  bf2BalanceDue: 'Baaki Rakam: ₹{amount} (wallet)',
  bf2Deadline: 'Deadline: {time} baaki',
  bf2ConfirmPayBtn: 'Confirm & Pay ₹{amount}',
  bf2Dispute: 'Vivaad',
  bf2DisputePlaceholder: 'Hours galat hai kyunki...',
  bf2SubmitDispute: 'Vivaad Bhejein',
  bf2DisputeRaised: 'Vivaad darj kiya. Admin review kar raha hai.',
  bf2CompletedSummary: 'Kul: ₹{total} · Advance: ₹{advance}',
  bf2CompletedHours: ' · {hours} hrs',
  bf2ActualWorkRequired: 'Vastavik kaam ka samay (HH:MM:SS)',
  bf2LogWorkConfirm: 'Booking #{ref} ke liye {time} ({hours} hrs) log karein? Client ko suchit kiya jaayega.',
  bf2MarkCompleteFailed: 'Poora mark karna failed',
  etaOwnerApproval: 'Maalik ki manjoori ki prateeksha',
  etaWorkInProgress: 'Anumaanit poornata',
  etaPaymentDeadline: 'Bhugtan pushti ki samay seema',
  etaWorkCompleted: 'Kaary poorn hua',
  etaDisputeReview: 'DE team vivad ki samiksha kar rahi hai',
  etaMinutesRemaining: '{n} minute shesh',
  etaHoursRemaining: '{n} ghante shesh',
  activeBookingWarning: 'इस मशीन पर पहले से एक बुकिंग active है (#{{ref}}). नई बुकिंग से पहले उसे पूरा करें.',
  blacklistWarnBookingsCancelled: 'सभी बुकिंग रद्द हो जाएंगी',
  blacklistWarnClientMachine: 'क्लाइंट और मशीन ब्लैकलिस्ट हो जाएंगे',
  blacklistWarnLegalAction: 'कानूनी कार्रवाई की जाएगी',
  blacklistWarnWalletFrozen: 'वॉलेट बैलेंस फ्रीज हो जाएगा',
  changeMobileNumber: 'मोबाइल नंबर बदलें',
  closeMenuAria: 'मेनू बंद करें',
  confirmAdvanceLabel: 'अग्रिम',
  confirmPassword: 'पासवर्ड की पुष्टि करें',
  confirmWalletAfterLabel: 'बाद में वॉलेट',
  forgotPasswordChooseMethod: 'पासवर्ड रीसेट के लिए ईमेल लिंक या SMS OTP चुनें.',
  forgotPasswordEmailDevHint: 'Local dev: API server terminal खोलें और "Password reset link (development)" URL कॉपी करें.',
  forgotPasswordEmailDevOpenLink: 'रीसेट लिंक खोलें (development)',
  forgotPasswordEmailHint: 'अपना पंजीकृत admin ईमेल पता दर्ज करें.',
  forgotPasswordEmailNextStepBody: 'यदि खाता मौजूद है, तो पंजीकृत ईमेल पर रीसेट लिंक भेजा गया. नया पासवर्ड सेट करने के लिए वह लिंक खोलें.',
  forgotPasswordEmailNextStepSpam: 'नहीं मिला? स्पैम चेक करें या कुछ मिनट प्रतीक्षा करें, फिर दोबारा भेजें.',
  forgotPasswordEmailNextStepTitle: 'अपना ईमेल जांचें',
  forgotPasswordEmailStep1: 'अपना ईमेल इनबॉक्स खोलें',
  forgotPasswordEmailStep2: 'रीसेट पासवर्ड लिंक पर टैप करें',
  forgotPasswordEmailStep3: 'अगली स्क्रीन पर नया पासवर्ड सेट करें',
  forgotPasswordFailed: 'रीसेट लिंक नहीं भेजा जा सका. कृपया पुनः प्रयास करें.',
  forgotPasswordIntro: 'हम आपके पंजीकृत ईमेल पर एक सुरक्षित रीसेट लिंक भेजेंगे.',
  forgotPasswordInvalidEmail: 'कृपया एक वैध ईमेल पता दर्ज करें.',
  forgotPasswordInvalidOtp: 'SMS से 6 अंकों का OTP दर्ज करें.',
  forgotPasswordInvalidPhone: 'कृपया वैध 10 अंकों का मोबाइल नंबर दर्ज करें.',
  forgotPasswordLink: 'पासवर्ड भूल गए?',
  forgotPasswordOtpSentTo: 'OTP भेजा गया',
  forgotPasswordPhoneHint: 'अपना पंजीकृत मोबाइल नंबर दर्ज करें. रीसेट लिंक आपके खाते के ईमेल पर जाएगा.',
  forgotPasswordSendAgain: 'दूसरा लिंक भेजें',
  forgotPasswordSendOtp: 'OTP भेजें',
  forgotPasswordSending: 'भेज रहे हैं...',
  forgotPasswordSendingOtp: 'OTP भेज रहे हैं...',
  forgotPasswordSmsDevHint: 'SMS production में अभी configured नहीं — development में server logs में OTP code देखें.',
  forgotPasswordSmsFailed: 'OTP नहीं भेजा जा सका. कृपया पुनः प्रयास करें.',
  forgotPasswordSmsHint: 'अपना पंजीकृत मोबाइल नंबर दर्ज करें. SMS द्वारा 6 अंकों का OTP भेजा जाएगा.',
  forgotPasswordSmsSuccess: 'यदि खाता मौजूद है, तो OTP पंजीकृत मोबाइल पर भेजा गया.',
  forgotPasswordSubmit: 'रीसेट लिंक भेजें',
  forgotPasswordSuccess: 'यदि खाता मौजूद है, तो पंजीकृत ईमेल पर रीसेट निर्देश भेजे गए.',
  forgotPasswordTitle: 'पासवर्ड रीसेट करें',
  fuelNoteRefilledPlaceholder: 'नोट: 50 लीटर भरे...',
  gstInvoiceAfterComplete: 'बुकिंग Completed होने के बाद GST invoice उपलब्ध होगा.',
  invoiceCol: 'इनवॉइस',
  issueDescribePlaceholder: 'समस्या विस्तार से बताएं...',
  minPasswordPlaceholder: 'न्यूनतम 8 अक्षर',
  navigateToSite: '🗺️ साइट तक नेविगेट करें',
  newPassword: 'नया पासवर्ड',
  openInMaps: '📍 Maps में खोलें',
  operatorFullNamePlaceholder: 'ऑपरेटर का पूरा नाम',
  otpCode: 'OTP कोड',
  ownerHubAlertsSubtitle: 'बुकिंग और भुगतान अलर्ट',
  ownerHubAnalyticsSubtitle: 'प्रदर्शन और कमाई',
  ownerHubEditRegistrationSubtitle: 'अपनी मशीन का विवरण अपडेट करें',
  ownerHubKycSubtitle: 'पहचान सत्यापन पूर्ण करें',
  ownerHubMachinesSubtitle: 'अपने उपकरण देखें और प्रबंधित करें',
  ownerHubNotificationsSubtitle: 'प्लेटफॉर्म सूचनाएं',
  ownerHubOperatorsSubtitle: 'अपने ऑपरेटर प्रबंधित करें',
  ownerHubRegisterSubtitle: 'प्लेटफॉर्म पर नया उपकरण जोड़ें',
  ownerHubReportsSubtitle: 'मासिक बुकिंग रिपोर्ट',
  ownerHubSettingsSubtitle: 'प्रोफाइल और प्राथमिकताएं',
  ownerHubSupportSubtitle: 'सहायता और संपर्क',
  ownerHubTermsSubtitle: 'प्लेटफॉर्म नियम और नीतियां',
  ownerHubTrackingSubtitle: 'लाइव मशीन स्थान',
  ownerHubWalletSubtitle: 'बैलेंस और भुगतान देखें',
  ownerMarkWorkComplete: 'काम पूर्ण चिह्नित करें',
  ownerPaymentPendingWallet: 'निवल भुगतान लंबित — DE treasury जल्द आपके Payout Wallet में credit करेगा.',
  ownerPaymentReceivedBody: '₹{gross} का सकल बिलिंग दर्ज. आपके वॉलेट में निवल: ₹{net}.',
  ownerPaymentReceivedTitle: 'भुगतान प्राप्त',
  ownerWithdrawAmount: 'राशि (₹)',
  ownerWithdrawMin: 'न्यूनतम ₹1,000',
  ownerWithdrawSubmit: 'निकासी अनुरोध करें',
  ownerWithdrawSubmitted: 'निकासी अनुरोध सबमिट हुआ. Admin NEFT के बाद भुगतान (1-3 दिन).',
  ownerWithdrawTitle: 'बैंक में निकासी',
  ownerWorkCompleting: 'पूर्ण हो रहा है…',
  passwordsMustMatch: 'पासवर्ड और पुष्टि पासवर्ड मेल खाने चाहिए.',
  processingLabel: 'प्रोसेस हो रहा है…',
  rechargePlus: '+ रिचार्ज',
  resetMethodEmail: 'ईमेल लिंक',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'पासवर्ड रीसेट नहीं हो सका. नया लिंक अनुरोध करें.',
  resetPasswordIntro: 'कम से कम 8 अक्षरों वाला मजबूत पासवर्ड चुनें.',
  resetPasswordMinLength: 'पासवर्ड कम से कम 8 अक्षर का होना चाहिए.',
  resetPasswordMissingToken: 'रीसेट लिंक गायब या अमान्य है. लॉगिन से Forgot password उपयोग करें.',
  resetPasswordSubmit: 'पासवर्ड अपडेट करें',
  resetPasswordSuccess: 'पासवर्ड अपडेट हुआ. लॉगिन पर redirect हो रहे हैं...',
  resetPasswordTitle: 'नया पासवर्ड सेट करें',
  resetPasswordUpdating: 'अपडेट हो रहा है...',
  siteAddressLabel: 'साइट पता',
  siteGpsDenied: 'स्थान अनुमति अस्वीकृत. पता मैन्युअल दर्ज करें या GPS सक्षम करें.',
  siteGpsLoading: 'स्थान प्राप्त हो रहा है…',
  siteGpsUnavailable: 'GPS अनुपलब्ध. पता मैन्युअल दर्ज करें.',
  siteLocationOptional: 'वैकल्पिक — ऑपरेटर को साइट जल्दी ढूंढने में मदद करता है.',
  siteLocationTitle: 'साइट स्थान',
  sitePincodeLabel: 'पिनकोड',
  surveyQrBlockConfirm: 'फ्रीलांसर {code} को block करें? उनका referral link तुरंत बंद हो जाएगा.',
  surveyQrBlockFreelancer: 'Block करें',
  surveyQrFreelancerBlocked: 'Blocked: {code} — referral link अक्षम.',
  surveyQrFreelancerStatus: 'स्थिति',
  surveyQrFreelancerUnblocked: 'Unblocked: {code} — referral link सक्रिय.',
  surveyQrStatusActive: 'सक्रिय',
  surveyQrStatusBlocked: 'Blocked',
  surveyQrUnblockConfirm: 'फ्रीलांसर {code} को unblock करें और उनका referral link पुनः सक्षम करें?',
  surveyQrUnblockFreelancer: 'Unblock करें',
  surveySelectRole: 'अपनी भूमिका चुनें',
  surveyWhoAreYou: 'आप कौन हैं?',
  surveyChooseOne: 'जारी रखने के लिए एक विकल्प चुनें.',
  surveyOwnerTitle: 'मशीन मालिक',
  surveyOwnerSubtitle: 'फ्लीट मालिक · JCB / एक्स्कॅव्हेटर',
  surveyClientNeedTitle: 'मुझे मशीन चाहिए',
  surveyClientNeedSubtitle: 'अपने प्रोजेक्ट के लिए मशीन किराए पर लें',
  surveyPmTitle: 'प्रोजेक्ट मैनेजर',
  surveyPmSubtitle: 'कन्स्ट्रक्शन कंपनी · कॉन्ट्रॅक्टर फर्म',
  surveyContractorTitle: 'स्वतंत्र ठेकेदार',
  surveyContractorSubtitle: 'अपना खुद का प्रोजेक्ट चलाते हैं',
  tableBase: 'आधार',
  tableGst: 'GST',
  transactionsCount: '{count} लेनदेन',
  txnDayNet: 'दिन का नेट',
  useCurrentLocation: '📍 वर्तमान स्थान उपयोग करें',
};

const TE = {
  availableNow: 'ఇప్పుడు అందుబాటులో',
  avgRating: 'సగటు రేటింగ్',
  advancePaid: 'అడ్వాన్స్ చెల్లించబడింది',
  quantityLabel: 'పరిమాణం',
  currentlyDeployed: 'ప్రస్తుతం డిప్లాయ్',
  liveMachineLocation: 'లైవ్ మెషీన్ స్థానం',
  quickRechargeUpi: 'UPI ద్వారా త్వరిత రీఛార్జ్',
  scanToPay: 'చెల్లించడానికి స్కాన్ చేయండి',
  quickSelect: 'త్వరిత ఎంపిక:',
  filterAll: 'అన్నీ',
  filterCredit: 'క్రెడిట్',
  filterDebit: 'డెబిట్',
  txnDescription: 'వివరణ',
  noTransactionsFilter: 'ఎంచుకున్న ఫిల్టర్‌కు లావాదేవీలు లేవు.',
  noBookingsAccount: 'ఈ ఖాతాకు ఇంకా బుకింగ్‌లు లేవు.',
  invoiceNotAvailableCancelled: 'ఇన్వాయిస్ అందుబాటులో లేదు (రద్దు)',
  noAlertsNow: 'ప్రస్తుతం అలర్ట్‌లు లేవు.',
  bookingsCount: '{count} బుకింగ్‌లు',
  pendingCount: '{count} పెండింగ్',
  directContactBlacklist: 'ప్రత్యక్ష సంపర్కం = బ్లాక్‌లిస్ట్',
  pdfInvoiceFailed: 'ఇన్వాయిస్ PDF సృష్టించలేకపోయాము. మళ్లీ ప్రయత్నించండి.',
  pdfReportFailed: 'రిపోర్ట్ PDF సృష్టించలేకపోయాము. మళ్లీ ప్రయత్నించండి.',
  bookingFailedGeneric: 'బుకింగ్ విఫలమైంది. మళ్లీ ప్రయత్నించండి.',
  machineIdLabel: 'మెషీన్ ID',
  yearsExperience: '{n} సంవత్సరాలు',
  fuelColon: 'ఇంధనం:',
  hrsUnit: 'గంటలు',
  daysUnit: 'రోజులు',
  wksUnit: 'వారాలు',
  moUnit: 'నెలలు',
  walletDebit: 'వాలెట్ డెబిట్',
  statusCancelled: 'రద్దు',
  statusCompleted: 'పూర్తి',
  naLabel: 'వర్తించదు',
  loadedOwnerBookings: '{count} యజమాని బుకింగ్‌లు లోడ్{suffix}',
  ownerBookingsMoreAvailable: ' (మరిన్ని అందుబాటులో)',
  ownerBookingsAllLoaded: ' (అన్నీ లోడ్)',
  machineDispatchedAt: 'మెషీన్ పంపబడింది — {when}',
  loginIAmQuestion: 'నేను ఎవరు…?',
  loginPickRoleHint: 'నమోదైనవారా? పాత్ర ఎంచుకోండి. కొత్తవారా? క్రింద Join Us.',
  loginRoleClientDesc: 'నిర్మాణ ప్రాజెక్ట్‌లకు మెషినరీ బుక్ చేయండి',
  loginRoleOwnerDesc: 'ఫ్లీట్, ఆదాయం & లభ్యత నిర్వహించండి',
  loginRoleOperatorDesc: 'కేటాయించిన మెషీన్‌లు & రోజువారీ లాగ్‌లు',
  loginRoleAdminDesc: 'ప్లాట్‌ఫారమ్ నియంత్రణ, ఆమోదాలు & ఆపరేషన్స్',
  loginPortalClientTitle: 'గ్రాహకుడు పోర్టల్',
  loginPortalClientSubtitle: 'నిర్మాణ మెషినరీ బుక్ చేయడానికి సైన్ ఇన్',
  loginPortalOwnerTitle: 'యజమాని పోర్టల్',
  loginPortalOwnerSubtitle: 'ఫ్లీట్ & నమోదు నిర్వహించడానికి సైన్ ఇన్',
  loginPortalOperatorTitle: 'ఆపరేటర్ పోర్టల్',
  loginPortalOperatorSubtitle: 'కేటాయించిన మెషీన్‌లు & లాగ్‌ల కోసం సైన్ ఇన్',
  loginPortalAdminTitle: 'అడ్మిన్ పోర్టల్',
  loginPortalAdminSubtitle: 'ప్లాట్‌ఫారమ్ నియంత్రణ & ఆమోదాలు',
  trustStatMachines: 'మెషీన్‌లు',
  trustStatRating: 'రేటింగ్',
  trustStatCompliant: 'అనుపాలన',
  signupSectionContact: 'మీ వివరాలు',
  signupSectionCompany: 'కంపెనీ',
  signupSectionSecurity: 'భద్రత',
  signupContactName: 'సంప్రదింపు పేరు',
  signupCompanyName: 'కంపెనీ పేరు',
  signupCreatePassword: 'పాస్‌వర్డ్ సృష్టించండి',
  signupReenterPassword: 'పాస్‌వర్డ్ మళ్లీ నమోదు',
  timeLabel: 'సమయం',
  fuelHistoryTitle: 'ఇంధన చరిత్ర',
  fuelNotePlaceholder: 'గమనిక: నింపిన / ఉపయోగించిన ఇంధనం...',
  walletLowRecharge: 'వాలెట్ బ్యాలెన్స్ తక్కువ — తదుపరి బుకింగ్ ముందు రీఛార్జ్ చేయండి',
  recentLabel: 'ఇటీవలి',
  policyLabel: 'విధానం',
  supportPolicyBooking: 'వాలెట్-only అడ్వాన్స్. సైట్‌లో నగదు లేదు.',
  supportPolicyCancellation: '1 గంట జరిమానా; మిగిలినది వాలెట్‌కు.',
  supportPolicyContact: 'DE Support మాత్రమే — ప్రత్యక్ష డ్రైవర్ సంపర్కం నిషేధం.',
  supportPolicyGst: 'అన్ని ఇన్వాయిస్‌లపై 18% GST; Reports ట్యాబ్ నుండి డౌన్‌లోడ్.',
  supportPolicyHours: 'సోమ–శని, 9–7 IST',
  machineDefaultLabel: 'మెషీన్',
  assignedOperator: 'కేటాయించిన ఆపరేటర్',
  machineDetailsTitle: 'మెషీన్ వివరాలు',
  bookingTypeLabel: 'బుకింగ్ రకం',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  marketingBuiltFor: 'ఖచ్చితత్వం, అనుపాలన మరియు వేగం కావాల్సిన భారతీయ నిర్మాణ బృందాల కోసం.',
  policyTopicBooking: 'బుకింగ్',
  policyTopicCancellation: 'రద్దు',
  policyTopicContact: 'సంపర్కం',
  policyTopicGst: 'GST',
  policyTopicHours: 'సపోర్ట్ సమయం',
  bf2AwaitingDispatch: 'Booking confirmed. Awaiting dispatch approval.',
  bf2OwnerApprovedSoon: 'Owner approved — machine will start soon.',
  bf2Active: 'ACTIVE',
  bf2MachineHoursLive: 'Machine Hours (Live)',
  bf2Booked: 'Booked',
  bf2Remaining: 'Remaining',
  bf2RunningBill: 'Running Bill',
  bf2Outstanding: 'Outstanding',
  bf2MinimumBilling: 'Minimum {hours} hrs billing applies (₹{amount})',
  bf2AdvancePaid: 'Advance Paid',
  bf2Started: 'Started',
  bf2ExtendHr: '+ Extend {hours}hr',
  bf2ExtendConfirm: '+ Extend {hours} hr — confirm?\n\nTotal: ₹{total}\nAdvance (50%): ₹{advance}\n\n₹{advance} will be deducted from your wallet.',
  bf2ExtendSuccess: '✅ {hours} hr added!\n₹{advance} debited from your wallet.',
  bf2ExtensionPending: 'Extension requested. Pay advance to continue.',
  bf2ConfirmWorkComplete: 'Confirm Work Complete',
  bf2OperatorLogged: 'Operator logged: {logged} hrs · Minimum: {min} hrs · Charged: {final} hrs',
  bf2BalanceDue: 'Balance Due: ₹{amount} (wallet)',
  bf2Deadline: 'Deadline: {time} remaining',
  bf2ConfirmPayBtn: 'Confirm & Pay ₹{amount}',
  bf2Dispute: 'Dispute',
  bf2DisputePlaceholder: 'Hours are wrong because...',
  bf2SubmitDispute: 'Submit Dispute',
  bf2DisputeRaised: 'Dispute raised. Admin is reviewing.',
  bf2CompletedSummary: 'Total: ₹{total} · Advance: ₹{advance}',
  bf2CompletedHours: ' · {hours} hrs',
  bf2ActualWorkRequired: 'Actual work time required (HH:MM:SS)',
  bf2LogWorkConfirm: 'Log {time} ({hours} hrs) for Booking #{ref}? Client will be notified.',
  bf2MarkCompleteFailed: 'Failed to mark complete',
  etaOwnerApproval: 'Awaiting owner approval',
  etaWorkInProgress: 'Estimated completion',
  etaPaymentDeadline: 'Payment confirmation deadline',
  etaWorkCompleted: 'Work completed at',
  etaDisputeReview: 'Dispute under review by DE team',
  etaMinutesRemaining: '{n} minutes remaining',
  etaHoursRemaining: '{n} hours remaining',
};

const KN = {
  availableNow: 'ಈಗ ಲಭ್ಯ',
  avgRating: 'ಸರಾಸರಿ ರೇಟಿಂಗ್',
  advancePaid: 'ಮುಂಗಡ ಪಾವತಿ',
  quantityLabel: 'ಪ್ರಮಾಣ',
  currentlyDeployed: 'ಪ್ರಸ್ತುತ ನಿಯೋಜಿತ',
  liveMachineLocation: 'ಲೈವ್ ಯಂತ್ರ ಸ್ಥಾನ',
  quickRechargeUpi: 'UPI ಮೂಲಕ ತ್ವರಿತ ರೀಚಾರ್ಜ್',
  scanToPay: 'ಪಾವತಿಗಾಗಿ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ',
  quickSelect: 'ತ್ವರಿತ ಆಯ್ಕೆ:',
  filterAll: 'ಎಲ್ಲಾ',
  filterCredit: 'ಕ್ರೆಡಿಟ್',
  filterDebit: 'ಡೆಬಿಟ್',
  txnDescription: 'ವಿವರಣೆ',
  noTransactionsFilter: 'ಆಯ್ಕೆಮಾಡಿದ ಫಿಲ್ಟರ್‌ಗೆ ವಹಿವಾಟುಗಳಿಲ್ಲ.',
  noBookingsAccount: 'ಈ ಖಾತೆಗೆ ಇನ್ನೂ ಬುಕಿಂಗ್ ಇಲ್ಲ.',
  invoiceNotAvailableCancelled: 'ಇನ್‌ವಾಯ್ಸ್ ಲಭ್ಯವಿಲ್ಲ (ರದ್ದು)',
  noAlertsNow: 'ಈಗ ಎಚ್ಚರಿಕೆಗಳಿಲ್ಲ.',
  bookingsCount: '{count} ಬುಕಿಂಗ್‌ಗಳು',
  pendingCount: '{count} ಬಾಕಿ',
  directContactBlacklist: 'ನೇರ ಸಂಪರ್ಕ = ಬ್ಲಾಕ್‌ಲಿಸ್ಟ್',
  pdfInvoiceFailed: 'ಇನ್‌ವಾಯ್ಸ್ PDF ರಚಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  pdfReportFailed: 'ವರದಿ PDF ರಚಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  bookingFailedGeneric: 'ಬುಕಿಂಗ್ ವಿಫಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  machineIdLabel: 'ಯಂತ್ರ ID',
  yearsExperience: '{n} ವರ್ಷ',
  fuelColon: 'ಇಂಧನ:',
  hrsUnit: 'ಗಂಟೆ',
  daysUnit: 'ದಿನ',
  wksUnit: 'ವಾರ',
  moUnit: 'ತಿಂಗಳು',
  walletDebit: 'ವಾಲೆಟ್ ಡೆಬಿಟ್',
  statusCancelled: 'ರದ್ದು',
  statusCompleted: 'ಪೂರ್ಣ',
  naLabel: 'ಅನ್ವಯಿಸುವುದಿಲ್ಲ',
  loadedOwnerBookings: '{count} ಮಾಲೀಕ ಬುಕಿಂಗ್ ಲೋಡ್{suffix}',
  ownerBookingsMoreAvailable: ' (ಇನ್ನೂ ಲಭ್ಯ)',
  ownerBookingsAllLoaded: ' (ಎಲ್ಲಾ ಲೋಡ್)',
  machineDispatchedAt: 'ಯಂತ್ರ ಕಳುಹಿಸಲಾಗಿದೆ — {when}',
  loginIAmQuestion: 'ನಾನು ಯಾರು…?',
  loginPickRoleHint: 'ನೋಂದಾಯಿತ? ಪಾತ್ರ ಆಯ್ಕೆಮಾಡಿ. ಹೊಸವರಾ? ಕೆಳಗೆ Join Us.',
  loginRoleClientDesc: 'ನಿರ್ಮಾಣ ಯೋಜನೆಗಳಿಗೆ ಮೆಷಿನರಿ ಬುಕ್ ಮಾಡಿ',
  loginRoleOwnerDesc: 'ಫ್ಲೀಟ್, ಆದಾಯ ಮತ್ತು ಲಭ್ಯತೆ ನಿರ್ವಹಿಸಿ',
  loginRoleOperatorDesc: 'ನಿಯೋಜಿತ ಯಂತ್ರಗಳು ಮತ್ತು ದೈನಂದಿನ ಲಾಗ್‌ಗಳು',
  loginRoleAdminDesc: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ನಿಯಂತ್ರಣ, ಅನುಮೋದನೆಗಳು',
  loginPortalClientTitle: 'ಗ್ರಾಹಕ ಪೋರ್ಟಲ್',
  loginPortalClientSubtitle: 'ನಿರ್ಮಾಣ ಮೆಷಿನರಿ ಬುಕ್ ಮಾಡಲು ಸೈನ್ ಇನ್',
  loginPortalOwnerTitle: 'ಮಾಲೀಕ ಪೋರ್ಟಲ್',
  loginPortalOwnerSubtitle: 'ಫ್ಲೀಟ್ ಮತ್ತು ನೋಂದಣಿ ನಿರ್ವಹಿಸಲು ಸೈನ್ ಇನ್',
  loginPortalOperatorTitle: 'ಆಪರೇಟರ್ ಪೋರ್ಟಲ್',
  loginPortalOperatorSubtitle: 'ನಿಯೋಜಿತ ಯಂತ್ರಗಳಿಗೆ ಸೈನ್ ಇನ್',
  loginPortalAdminTitle: 'ಅಡ್ಮಿನ್ ಪೋರ್ಟಲ್',
  loginPortalAdminSubtitle: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ನಿಯಂತ್ರಣ ಮತ್ತು ಅನುಮೋದನೆ',
  trustStatMachines: 'ಯಂತ್ರಗಳು',
  trustStatRating: 'ರೇಟಿಂಗ್',
  trustStatCompliant: 'ಅನುಪಾಲನೆ',
  signupSectionContact: 'ನಿಮ್ಮ ವಿವರಗಳು',
  signupSectionCompany: 'ಕಂಪನಿ',
  signupSectionSecurity: 'ಭದ್ರತೆ',
  signupContactName: 'ಸಂಪರ್ಕ ಹೆಸರು',
  signupCompanyName: 'ಕಂಪನಿ ಹೆಸರು',
  signupCreatePassword: 'ಪಾಸ್‌ವರ್ಡ್ ರಚಿಸಿ',
  signupReenterPassword: 'ಪಾಸ್‌ವರ್ಡ್ ಮತ್ತೆ ನಮೂದಿಸಿ',
  timeLabel: 'ಸಮಯ',
  fuelHistoryTitle: 'ಇಂಧನ ಇತಿಹಾಸ',
  fuelNotePlaceholder: 'ಟಿಪ್ಪಣಿ: ತುಂಬಿದ / ಬಳಸಿದ ಇಂಧನ...',
  walletLowRecharge: 'ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್ ಕಡಿಮೆ — ಮುಂದಿನ ಬುಕಿಂಗ್ ಮೊದಲು ರೀಚಾರ್ಜ್',
  recentLabel: 'ಇತ್ತೀಚಿನ',
  policyLabel: 'ನೀತಿ',
  supportPolicyBooking: 'ವಾಲೆಟ್-only ಮುಂಗಡ. ಸೈಟ್‌ನಲ್ಲಿ ನಗದು ಇಲ್ಲ.',
  supportPolicyCancellation: '1 ಗಂಟೆ ದಂಡ; ಬಾಕಿ ವಾಲೆಟ್‌ಗೆ.',
  supportPolicyContact: 'DE Support ಮಾತ್ರ — ನೇರ ಡ್ರೈವರ್ ಸಂಪರ್ಕ ನಿಷೇಧ.',
  supportPolicyGst: 'ಎಲ್ಲಾ ಇನ್‌ವಾಯ್ಸ್‌ನಲ್ಲಿ 18% GST; Reports ಟ್ಯಾಬ್‌ನಿಂದ.',
  supportPolicyHours: 'ಸೋಮ–ಶನಿ, 9–7 IST',
  machineDefaultLabel: 'ಯಂತ್ರ',
  assignedOperator: 'ನಿಯೋಜಿತ ಆಪರೇಟರ್',
  machineDetailsTitle: 'ಯಂತ್ರ ವಿವರಗಳು',
  bookingTypeLabel: 'ಬುಕಿಂಗ್ ಪ್ರಕಾರ',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  marketingBuiltFor: 'ನಿಖರತೆ, ಅನುಪಾಲನೆ ಮತ್ತು ವೇಗ ಬೇಕಾದ ಭಾರತೀಯ ನಿರ್ಮಾಣ ತಂಡಗಳಿಗೆ.',
  policyTopicBooking: 'ಬುಕಿಂಗ್',
  policyTopicCancellation: 'ರದ್ದು',
  policyTopicContact: 'ಸಂಪರ್ಕ',
  policyTopicGst: 'GST',
  policyTopicHours: 'ಸಪೋರ್ಟ್ ಸಮಯ',
  bf2AwaitingDispatch: 'Booking confirmed. Awaiting dispatch approval.',
  bf2OwnerApprovedSoon: 'Owner approved — machine will start soon.',
  bf2Active: 'ACTIVE',
  bf2MachineHoursLive: 'Machine Hours (Live)',
  bf2Booked: 'Booked',
  bf2Remaining: 'Remaining',
  bf2RunningBill: 'Running Bill',
  bf2Outstanding: 'Outstanding',
  bf2MinimumBilling: 'Minimum {hours} hrs billing applies (₹{amount})',
  bf2AdvancePaid: 'Advance Paid',
  bf2Started: 'Started',
  bf2ExtendHr: '+ Extend {hours}hr',
  bf2ExtendConfirm: '+ Extend {hours} hr — confirm?\n\nTotal: ₹{total}\nAdvance (50%): ₹{advance}\n\n₹{advance} will be deducted from your wallet.',
  bf2ExtendSuccess: '✅ {hours} hr added!\n₹{advance} debited from your wallet.',
  bf2ExtensionPending: 'Extension requested. Pay advance to continue.',
  bf2ConfirmWorkComplete: 'Confirm Work Complete',
  bf2OperatorLogged: 'Operator logged: {logged} hrs · Minimum: {min} hrs · Charged: {final} hrs',
  bf2BalanceDue: 'Balance Due: ₹{amount} (wallet)',
  bf2Deadline: 'Deadline: {time} remaining',
  bf2ConfirmPayBtn: 'Confirm & Pay ₹{amount}',
  bf2Dispute: 'Dispute',
  bf2DisputePlaceholder: 'Hours are wrong because...',
  bf2SubmitDispute: 'Submit Dispute',
  bf2DisputeRaised: 'Dispute raised. Admin is reviewing.',
  bf2CompletedSummary: 'Total: ₹{total} · Advance: ₹{advance}',
  bf2CompletedHours: ' · {hours} hrs',
  bf2ActualWorkRequired: 'Actual work time required (HH:MM:SS)',
  bf2LogWorkConfirm: 'Log {time} ({hours} hrs) for Booking #{ref}? Client will be notified.',
  bf2MarkCompleteFailed: 'Failed to mark complete',
  etaOwnerApproval: 'Awaiting owner approval',
  etaWorkInProgress: 'Estimated completion',
  etaPaymentDeadline: 'Payment confirmation deadline',
  etaWorkCompleted: 'Work completed at',
  etaDisputeReview: 'Dispute under review by DE team',
  etaMinutesRemaining: '{n} minutes remaining',
  etaHoursRemaining: '{n} hours remaining',
};

const TA = {
  availableNow: 'இப்போது கிடைக்கிறது',
  avgRating: 'சராசரி மதிப்பீடு',
  advancePaid: 'முன்பணம் செலுத்தப்பட்டது',
  quantityLabel: 'அளவு',
  currentlyDeployed: 'தற்போது பணியில்',
  liveMachineLocation: 'நேரடி இயந்திர இடம்',
  quickRechargeUpi: 'UPI வழி விரைவு ரீசார்ஜ்',
  scanToPay: 'பணம் செலுத்த ஸ்கேன் செய்யுங்கள்',
  quickSelect: 'விரைவு தேர்வு:',
  filterAll: 'அனைத்தும்',
  filterCredit: 'கிரெடிட்',
  filterDebit: 'டெபிட்',
  txnDescription: 'விவரம்',
  noTransactionsFilter: 'தேர்ந்தெடுத்த வடிகட்டிக்கு பரிவர்த்தனைகள் இல்லை.',
  noBookingsAccount: 'இந்த கணக்கிற்கு இன்னும் முன்பதிவு இல்லை.',
  invoiceNotAvailableCancelled: 'விலைப்பட்டியல் இல்லை (ரத்து)',
  noAlertsNow: 'இப்போது எச்சரிக்கைகள் இல்லை.',
  bookingsCount: '{count} முன்பதிவுகள்',
  pendingCount: '{count} நிலுவை',
  directContactBlacklist: 'நேரடி தொடர்பு = பிளாக்லிஸ்ட்',
  pdfInvoiceFailed: 'விலைப்பட்டியல் PDF உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  pdfReportFailed: 'அறிக்கை PDF உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  bookingFailedGeneric: 'முன்பதிவு தோல்வி. மீண்டும் முயற்சிக்கவும்.',
  machineIdLabel: 'இயந்திர ID',
  yearsExperience: '{n} ஆண்டுகள்',
  fuelColon: 'எரிபொருள்:',
  hrsUnit: 'மணி',
  daysUnit: 'நாள்',
  wksUnit: 'வாரம்',
  moUnit: 'மாதம்',
  walletDebit: 'வாலட் டெபிட்',
  statusCancelled: 'ரத்து',
  statusCompleted: 'முடிந்தது',
  naLabel: 'பொருந்தாது',
  loadedOwnerBookings: '{count} உரிமையாளர் முன்பதிவுகள் ஏற்றப்பட்டது{suffix}',
  ownerBookingsMoreAvailable: ' (மேலும் உள்ளது)',
  ownerBookingsAllLoaded: ' (அனைத்தும் ஏற்றப்பட்டது)',
  machineDispatchedAt: 'இயந்திரம் அனுப்பப்பட்டது — {when}',
  loginIAmQuestion: 'நான் யார்…?',
  loginPickRoleHint: 'பதிவு செய்தவரா? பாத்திரம் தேர்ந்தெடுக்கவும். புதியவரா? கீழே Join Us.',
  loginRoleClientDesc: 'கட்டுமான திட்டங்களுக்கு இயந்திரம் புக் செய்யுங்கள்',
  loginRoleOwnerDesc: 'கப்பல், வருவாய் & கிடைப்பு நிர்வகிக்கவும்',
  loginRoleOperatorDesc: 'ஒதுக்கப்பட்ட இயந்திரங்கள் & தினசரி பதிவுகள்',
  loginRoleAdminDesc: 'தள கட்டுப்பாடு, அனுமதிகள் & செயல்பாடுகள்',
  loginPortalClientTitle: 'வாடிக்கையாளர் போர்டல்',
  loginPortalClientSubtitle: 'கட்டுமான இயந்திரம் புக் செய்ய உள்நுழையுங்கள்',
  loginPortalOwnerTitle: 'உரிமையாளர் போர்டல்',
  loginPortalOwnerSubtitle: 'கப்பல் & பதிவு நிர்வகிக்க உள்நுழையுங்கள்',
  loginPortalOperatorTitle: 'ஆபரேட்டர் போர்டல்',
  loginPortalOperatorSubtitle: 'ஒதுக்கப்பட்ட இயந்திரங்களுக்கு உள்நுழையுங்கள்',
  loginPortalAdminTitle: 'அட்மின் போர்டல்',
  loginPortalAdminSubtitle: 'தள கட்டுப்பாடு & அனுமதிகள்',
  trustStatMachines: 'இயந்திரங்கள்',
  trustStatRating: 'மதிப்பீடு',
  trustStatCompliant: 'இணக்கம்',
  signupSectionContact: 'உங்கள் விவரங்கள்',
  signupSectionCompany: 'நிறுவனம்',
  signupSectionSecurity: 'பாதுகாப்பு',
  signupContactName: 'தொடர்பு பெயர்',
  signupCompanyName: 'நிறுவன பெயர்',
  signupCreatePassword: 'கடவுச்சொல் உருவாக்கு',
  signupReenterPassword: 'கடவுச்சொல் மீண்டும்',
  timeLabel: 'நேரம்',
  fuelHistoryTitle: 'எரிபொருள் வரலாறு',
  fuelNotePlaceholder: 'குறிப்பு: நிரப்பிய / பயன்படுத்திய எரிபொருள்...',
  walletLowRecharge: 'வாலட் இருப்பு குறைவு — அடுத்த முன்பதிவுக்கு முன் ரீசார்ஜ்',
  recentLabel: 'சமீபத்திய',
  policyLabel: 'கொள்கை',
  supportPolicyBooking: 'வாலட்-only முன்பணம். தளத்தில் பணம் இல்லை.',
  supportPolicyCancellation: '1 மணி அபராதம்; மீதம் வாலட்டில்.',
  supportPolicyContact: 'DE Support மட்டும் — நேரடி தொடர்பு தடை.',
  supportPolicyGst: 'அனைத்து விலைப்பட்டியலிலும் 18% GST; Reports தாவலில்.',
  supportPolicyHours: 'திங்–சனி, 9–7 IST',
  machineDefaultLabel: 'இயந்திரம்',
  assignedOperator: 'ஒதுக்கப்பட்ட ஆபரேட்டர்',
  machineDetailsTitle: 'இயந்திர விவரங்கள்',
  bookingTypeLabel: 'முன்பதிவு வகை',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  marketingBuiltFor: 'துல்லியம், இணக்கம், வேகம் வேண்டிய இந்திய கட்டுமான குழுக்களுக்கு.',
  policyTopicBooking: 'முன்பதிவு',
  policyTopicCancellation: 'ரத்து',
  policyTopicContact: 'தொடர்பு',
  policyTopicGst: 'GST',
  policyTopicHours: 'ஆதரவு நேரம்',
  bf2AwaitingDispatch: 'Booking confirmed. Awaiting dispatch approval.',
  bf2OwnerApprovedSoon: 'Owner approved — machine will start soon.',
  bf2Active: 'ACTIVE',
  bf2MachineHoursLive: 'Machine Hours (Live)',
  bf2Booked: 'Booked',
  bf2Remaining: 'Remaining',
  bf2RunningBill: 'Running Bill',
  bf2Outstanding: 'Outstanding',
  bf2MinimumBilling: 'Minimum {hours} hrs billing applies (₹{amount})',
  bf2AdvancePaid: 'Advance Paid',
  bf2Started: 'Started',
  bf2ExtendHr: '+ Extend {hours}hr',
  bf2ExtendConfirm: '+ Extend {hours} hr — confirm?\n\nTotal: ₹{total}\nAdvance (50%): ₹{advance}\n\n₹{advance} will be deducted from your wallet.',
  bf2ExtendSuccess: '✅ {hours} hr added!\n₹{advance} debited from your wallet.',
  bf2ExtensionPending: 'Extension requested. Pay advance to continue.',
  bf2ConfirmWorkComplete: 'Confirm Work Complete',
  bf2OperatorLogged: 'Operator logged: {logged} hrs · Minimum: {min} hrs · Charged: {final} hrs',
  bf2BalanceDue: 'Balance Due: ₹{amount} (wallet)',
  bf2Deadline: 'Deadline: {time} remaining',
  bf2ConfirmPayBtn: 'Confirm & Pay ₹{amount}',
  bf2Dispute: 'Dispute',
  bf2DisputePlaceholder: 'Hours are wrong because...',
  bf2SubmitDispute: 'Submit Dispute',
  bf2DisputeRaised: 'Dispute raised. Admin is reviewing.',
  bf2CompletedSummary: 'Total: ₹{total} · Advance: ₹{advance}',
  bf2CompletedHours: ' · {hours} hrs',
  bf2ActualWorkRequired: 'Actual work time required (HH:MM:SS)',
  bf2LogWorkConfirm: 'Log {time} ({hours} hrs) for Booking #{ref}? Client will be notified.',
  bf2MarkCompleteFailed: 'Failed to mark complete',
  etaOwnerApproval: 'Awaiting owner approval',
  etaWorkInProgress: 'Estimated completion',
  etaPaymentDeadline: 'Payment confirmation deadline',
  etaWorkCompleted: 'Work completed at',
  etaDisputeReview: 'Dispute under review by DE team',
  etaMinutesRemaining: '{n} minutes remaining',
  etaHoursRemaining: '{n} hours remaining',
};

const GU = {
  availableNow: 'હવે ઉપલબ્ધ',
  avgRating: 'સરેરાશ રેટિંગ',
  advancePaid: 'અગ્રિમ ચૂકવ્યું',
  quantityLabel: 'જથો',
  currentlyDeployed: 'હાલમાં તૈનાત',
  liveMachineLocation: 'લાઇવ મશીન સ્થાન',
  quickRechargeUpi: 'UPI દ્વારા ઝડપી રિચાર્જ',
  scanToPay: 'ચૂકવણી માટે સ્કેન કરો',
  quickSelect: 'ઝડપી પસંદગી:',
  filterAll: 'બધા',
  filterCredit: 'ક્રેડિટ',
  filterDebit: 'ડેબિટ',
  txnDescription: 'વર્ણન',
  noTransactionsFilter: 'પસંદ ફિલ્ટર માટે વ્યવહાર નથી.',
  noBookingsAccount: 'આ ખાતા માટે હજી બુકિંગ નથી.',
  invoiceNotAvailableCancelled: 'ઇન્વૉઇસ ઉપલબ્ધ નથી (રદ)',
  noAlertsNow: 'હમણાં કોઈ અલર્ટ નથી.',
  bookingsCount: '{count} બુકિંગ',
  pendingCount: '{count} બાકી',
  directContactBlacklist: 'સીધો સંપર્ક = બ્લેકલિસ્ટ',
  pdfInvoiceFailed: 'ઇન્વૉઇસ PDF બનાવી શકાયું નહીં. ફરી પ્રયાસ કરો.',
  pdfReportFailed: 'રિપોર્ટ PDF બનાવી શકાયું નહીં. ફરી પ્રયાસ કરો.',
  bookingFailedGeneric: 'બુકિંગ નિષ્ફળ. ફરી પ્રયાસ કરો.',
  machineIdLabel: 'મશીન ID',
  yearsExperience: '{n} વર્ષ',
  fuelColon: 'બળતણ:',
  hrsUnit: 'કલાક',
  daysUnit: 'દિવસ',
  wksUnit: 'અઠવાડિયા',
  moUnit: 'મહિના',
  walletDebit: 'વૉલેટ ડેબિટ',
  statusCancelled: 'રદ',
  statusCompleted: 'પૂર્ણ',
  naLabel: 'લાગુ નથી',
  loadedOwnerBookings: '{count} માલિક બુકિંગ લોડ{suffix}',
  ownerBookingsMoreAvailable: ' (વધુ ઉપલબ્ધ)',
  ownerBookingsAllLoaded: ' (બધું લોડ)',
  machineDispatchedAt: 'મશીન મોકલાઈ — {when}',
  loginIAmQuestion: 'હું કોણ…?',
  loginPickRoleHint: 'નોંધાયેલ? ભૂમિકા પસંદ કરો. નવા? નીચે Join Us.',
  loginRoleClientDesc: 'બાંધકામ પ્રોજેક્ટ માટે મશીનરી બુક કરો',
  loginRoleOwnerDesc: 'ફ્લીટ, કમાણી અને ઉપલબ્ધતા સંચાલન',
  loginRoleOperatorDesc: 'સોંપેલ મશીન અને દૈનિક લોગ',
  loginRoleAdminDesc: 'પ્લેટફોર્મ નિયંત્રણ, મંજૂરી અને ઓપરેશન',
  loginPortalClientTitle: 'ગ્રાહક પોર્ટલ',
  loginPortalClientSubtitle: 'બાંધકામ મશીનરી બુક કરવા સાઇન ઇન',
  loginPortalOwnerTitle: 'માલિક પોર્ટલ',
  loginPortalOwnerSubtitle: 'ફ્લીટ અને નોંધણી સંચાલન માટે સાઇન ઇન',
  loginPortalOperatorTitle: 'ઓપરેટર પોર્ટલ',
  loginPortalOperatorSubtitle: 'સોંપેલ મશીન અને લોગ માટે સાઇન ઇન',
  loginPortalAdminTitle: 'એડમિન પોર્ટલ',
  loginPortalAdminSubtitle: 'પ્લેટફોર્મ નિયંત્રણ અને મંજૂરી',
  trustStatMachines: 'મશીન',
  trustStatRating: 'રેટિંગ',
  trustStatCompliant: 'અનુપાલન',
  signupSectionContact: 'તમારી વિગતો',
  signupSectionCompany: 'કંપની',
  signupSectionSecurity: 'સુરક્ષા',
  signupContactName: 'સંપર્ક નામ',
  signupCompanyName: 'કંપનીનું નામ',
  signupCreatePassword: 'પાસવર્ડ બનાવો',
  signupReenterPassword: 'પાસવર્ડ ફરી દાખલ કરો',
  timeLabel: 'સમય',
  fuelHistoryTitle: 'બળતણ ઇતિહાસ',
  fuelNotePlaceholder: 'નોંધ: ભર્યું / વપરાયેલ બળતણ...',
  walletLowRecharge: 'વૉલેટ બેલેન્સ ઓછું — આગલી બુકિંગ પહેલાં રિચાર્જ',
  recentLabel: 'તાજેતરનું',
  policyLabel: 'નીતિ',
  supportPolicyBooking: 'ફક્ત વૉલેટ અગ્રિમ. સાઇટ પર રોકડ નહીં.',
  supportPolicyCancellation: '1 કલાક દંડ; બાકી વૉલેટમાં.',
  supportPolicyContact: 'ફક્ત DE Support — સીધો ઓપરેટર સંપર્ક નિષેધ.',
  supportPolicyGst: 'બધા ઇન્વૉઇસ પર 18% GST; Reports ટેબમાંથી.',
  supportPolicyHours: 'સોમ–શનિ, 9–7 IST',
  machineDefaultLabel: 'મશીન',
  assignedOperator: 'સોંપેલ ઓપરેટર',
  machineDetailsTitle: 'મશીન વિગતો',
  bookingTypeLabel: 'બુકિંગ પ્રકાર',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  marketingBuiltFor: 'ચોકસાઈ, અનુપાલન અને ઝડપ જોઈતી ભારતીય બાંધકામ ટીમો માટે.',
  policyTopicBooking: 'બુકિંગ',
  policyTopicCancellation: 'રદ',
  policyTopicContact: 'સંપર્ક',
  policyTopicGst: 'GST',
  policyTopicHours: 'સપોર્ટ સમય',
  bf2AwaitingDispatch: 'Booking confirmed. Awaiting dispatch approval.',
  bf2OwnerApprovedSoon: 'Owner approved — machine will start soon.',
  bf2Active: 'ACTIVE',
  bf2MachineHoursLive: 'Machine Hours (Live)',
  bf2Booked: 'Booked',
  bf2Remaining: 'Remaining',
  bf2RunningBill: 'Running Bill',
  bf2Outstanding: 'Outstanding',
  bf2MinimumBilling: 'Minimum {hours} hrs billing applies (₹{amount})',
  bf2AdvancePaid: 'Advance Paid',
  bf2Started: 'Started',
  bf2ExtendHr: '+ Extend {hours}hr',
  bf2ExtendConfirm: '+ Extend {hours} hr — confirm?\n\nTotal: ₹{total}\nAdvance (50%): ₹{advance}\n\n₹{advance} will be deducted from your wallet.',
  bf2ExtendSuccess: '✅ {hours} hr added!\n₹{advance} debited from your wallet.',
  bf2ExtensionPending: 'Extension requested. Pay advance to continue.',
  bf2ConfirmWorkComplete: 'Confirm Work Complete',
  bf2OperatorLogged: 'Operator logged: {logged} hrs · Minimum: {min} hrs · Charged: {final} hrs',
  bf2BalanceDue: 'Balance Due: ₹{amount} (wallet)',
  bf2Deadline: 'Deadline: {time} remaining',
  bf2ConfirmPayBtn: 'Confirm & Pay ₹{amount}',
  bf2Dispute: 'Dispute',
  bf2DisputePlaceholder: 'Hours are wrong because...',
  bf2SubmitDispute: 'Submit Dispute',
  bf2DisputeRaised: 'Dispute raised. Admin is reviewing.',
  bf2CompletedSummary: 'Total: ₹{total} · Advance: ₹{advance}',
  bf2CompletedHours: ' · {hours} hrs',
  bf2ActualWorkRequired: 'Actual work time required (HH:MM:SS)',
  bf2LogWorkConfirm: 'Log {time} ({hours} hrs) for Booking #{ref}? Client will be notified.',
  bf2MarkCompleteFailed: 'Failed to mark complete',
  etaOwnerApproval: 'Awaiting owner approval',
  etaWorkInProgress: 'Estimated completion',
  etaPaymentDeadline: 'Payment confirmation deadline',
  etaWorkCompleted: 'Work completed at',
  etaDisputeReview: 'Dispute under review by DE team',
  etaMinutesRemaining: '{n} minutes remaining',
  etaHoursRemaining: '{n} hours remaining',
};

const BN = {
  availableNow: 'এখন উপলব্ধ',
  avgRating: 'গড় রেটিং',
  advancePaid: 'অগ্রিম প্রদত্ত',
  quantityLabel: 'পরিমাণ',
  currentlyDeployed: 'বর্তমানে মোতায়েন',
  liveMachineLocation: 'লাইভ মেশিন অবস্থান',
  quickRechargeUpi: 'UPI দিয়ে দ্রুত রিচার্জ',
  scanToPay: 'পেমেন্টের জন্য স্ক্যান করুন',
  quickSelect: 'দ্রুত নির্বাচন:',
  filterAll: 'সব',
  filterCredit: 'ক্রেডিট',
  filterDebit: 'ডেবিট',
  txnDescription: 'বিবরণ',
  noTransactionsFilter: 'নির্বাচিত ফিল্টারের জন্য লেনদেন নেই।',
  noBookingsAccount: 'এই অ্যাকাউন্টে এখনও বুকিং নেই।',
  invoiceNotAvailableCancelled: 'ইনভয়েস উপলব্ধ নয় (বাতিল)',
  noAlertsNow: 'এখন কোনো সতর্কতা নেই।',
  bookingsCount: '{count} বুকিং',
  pendingCount: '{count} মুলতুবি',
  directContactBlacklist: 'সরাসরি যোগাযোগ = ব্ল্যাকলিস্ট',
  pdfInvoiceFailed: 'ইনভয়েস PDF তৈরি করা যায়নি। আবার চেষ্টা করুন।',
  pdfReportFailed: 'রিপোর্ট PDF তৈরি করা যায়নি। আবার চেষ্টা করুন।',
  bookingFailedGeneric: 'বুকিং ব্যর্থ। আবার চেষ্টা করুন।',
  machineIdLabel: 'মেশিন ID',
  yearsExperience: '{n} বছর',
  fuelColon: 'জ্বালানি:',
  hrsUnit: 'ঘণ্টা',
  daysUnit: 'দিন',
  wksUnit: 'সপ্তাহ',
  moUnit: 'মাস',
  walletDebit: 'ওয়ালেট ডেবিট',
  statusCancelled: 'বাতিল',
  statusCompleted: 'সম্পন্ন',
  naLabel: 'প্রযোজ্য নয়',
  loadedOwnerBookings: '{count} মালিক বুকিং লোড{suffix}',
  ownerBookingsMoreAvailable: ' (আরও উপলব্ধ)',
  ownerBookingsAllLoaded: ' (সব লোড)',
  machineDispatchedAt: 'মেশিন পাঠানো হয়েছে — {when}',
  loginIAmQuestion: 'আমি কে…?',
  loginPickRoleHint: 'নিবন্ধিত? ভূমিকা বেছে নিন। নতুন? নিচে Join Us।',
  loginRoleClientDesc: 'নির্মাণ প্রকল্পের জন্য মেশিনারি বুক করুন',
  loginRoleOwnerDesc: 'ফ্লিট, আয় ও উপলব্ধতা পরিচালনা',
  loginRoleOperatorDesc: 'নিয়োজিত মেশিন ও দৈনিক লগ',
  loginRoleAdminDesc: 'প্ল্যাটফর্ম নিয়ন্ত্রণ, অনুমোদন ও অপারেশন',
  loginPortalClientTitle: 'গ্রাহক পোর্টাল',
  loginPortalClientSubtitle: 'নির্মাণ মেশিনারি বুক করতে সাইন ইন',
  loginPortalOwnerTitle: 'মালিক পোর্টাল',
  loginPortalOwnerSubtitle: 'ফ্লিট ও নিবন্ধন পরিচালনায় সাইন ইন',
  loginPortalOperatorTitle: 'অপারেটর পোর্টাল',
  loginPortalOperatorSubtitle: 'নিয়োজিত মেশিন ও লগের জন্য সাইন ইন',
  loginPortalAdminTitle: 'অ্যাডমিন পোর্টাল',
  loginPortalAdminSubtitle: 'প্ল্যাটফর্ম নিয়ন্ত্রণ ও অনুমোদন',
  trustStatMachines: 'মেশিন',
  trustStatRating: 'রেটিং',
  trustStatCompliant: 'সম্মতি',
  signupSectionContact: 'আপনার বিবরণ',
  signupSectionCompany: 'কোম্পানি',
  signupSectionSecurity: 'নিরাপত্তা',
  signupContactName: 'যোগাযোগের নাম',
  signupCompanyName: 'কোম্পানির নাম',
  signupCreatePassword: 'পাসওয়ার্ড তৈরি করুন',
  signupReenterPassword: 'পাসওয়ার্ড আবার লিখুন',
  timeLabel: 'সময়',
  fuelHistoryTitle: 'জ্বালানি ইতিহাস',
  fuelNotePlaceholder: 'নোট: ভরাট / ব্যবহৃত জ্বালানি...',
  walletLowRecharge: 'ওয়ালেট ব্যালেন্স কম — পরবর্তী বুকিংয়ের আগে রিচার্জ',
  recentLabel: 'সাম্প্রতিক',
  policyLabel: 'নীতি',
  supportPolicyBooking: 'শুধু ওয়ালেট অগ্রিম। সাইটে নগদ নয়।',
  supportPolicyCancellation: '১ ঘণ্টা জরিমানা; বাকি ওয়ালেটে।',
  supportPolicyContact: 'শুধু DE Support — সরাসরি অপারেটর যোগাযোগ নিষিদ্ধ।',
  supportPolicyGst: 'সব ইনভয়েসে 18% GST; Reports ট্যাবে ডাউনলোড।',
  supportPolicyHours: 'সোম–শনি, 9–7 IST',
  machineDefaultLabel: 'মেশিন',
  assignedOperator: 'নিয়োজিত অপারেটর',
  machineDetailsTitle: 'মেশিন বিবরণ',
  bookingTypeLabel: 'বুকিং ধরন',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  marketingBuiltFor: 'নির্ভুলতা, সম্মতি ও গতি চাই এমন ভারতীয় নির্মাণ দলের জন্য।',
  policyTopicBooking: 'বুকিং',
  policyTopicCancellation: 'বাতিল',
  policyTopicContact: 'যোগাযোগ',
  policyTopicGst: 'GST',
  policyTopicHours: 'সাপোর্ট সময়',
  bf2AwaitingDispatch: 'Booking confirmed. Awaiting dispatch approval.',
  bf2OwnerApprovedSoon: 'Owner approved — machine will start soon.',
  bf2Active: 'ACTIVE',
  bf2MachineHoursLive: 'Machine Hours (Live)',
  bf2Booked: 'Booked',
  bf2Remaining: 'Remaining',
  bf2RunningBill: 'Running Bill',
  bf2Outstanding: 'Outstanding',
  bf2MinimumBilling: 'Minimum {hours} hrs billing applies (₹{amount})',
  bf2AdvancePaid: 'Advance Paid',
  bf2Started: 'Started',
  bf2ExtendHr: '+ Extend {hours}hr',
  bf2ExtendConfirm: '+ Extend {hours} hr — confirm?\n\nTotal: ₹{total}\nAdvance (50%): ₹{advance}\n\n₹{advance} will be deducted from your wallet.',
  bf2ExtendSuccess: '✅ {hours} hr added!\n₹{advance} debited from your wallet.',
  bf2ExtensionPending: 'Extension requested. Pay advance to continue.',
  bf2ConfirmWorkComplete: 'Confirm Work Complete',
  bf2OperatorLogged: 'Operator logged: {logged} hrs · Minimum: {min} hrs · Charged: {final} hrs',
  bf2BalanceDue: 'Balance Due: ₹{amount} (wallet)',
  bf2Deadline: 'Deadline: {time} remaining',
  bf2ConfirmPayBtn: 'Confirm & Pay ₹{amount}',
  bf2Dispute: 'Dispute',
  bf2DisputePlaceholder: 'Hours are wrong because...',
  bf2SubmitDispute: 'Submit Dispute',
  bf2DisputeRaised: 'Dispute raised. Admin is reviewing.',
  bf2CompletedSummary: 'Total: ₹{total} · Advance: ₹{advance}',
  bf2CompletedHours: ' · {hours} hrs',
  bf2ActualWorkRequired: 'Actual work time required (HH:MM:SS)',
  bf2LogWorkConfirm: 'Log {time} ({hours} hrs) for Booking #{ref}? Client will be notified.',
  bf2MarkCompleteFailed: 'Failed to mark complete',
  etaOwnerApproval: 'Awaiting owner approval',
  etaWorkInProgress: 'Estimated completion',
  etaPaymentDeadline: 'Payment confirmation deadline',
  etaWorkCompleted: 'Work completed at',
  etaDisputeReview: 'Dispute under review by DE team',
  etaMinutesRemaining: '{n} minutes remaining',
  etaHoursRemaining: '{n} hours remaining',
};

export const UI_EXTRAS = {
  en: EN,
  mr: MR,
  hi: HI,
  te: TE,
  kn: KN,
  ta: TA,
  gu: GU,
  bn: BN,
  ml: ML,
};
